
    var riot = require('riot')
    //src: starling/src/tags/app.html
riot.tag2('app',
  '<zen-mode canvas="{this}" if="{!window.pageSettings.embedded}"></zen-mode> <div class="app_banners app_banners--top"> <perspectives-banner canvas="{this}"></perspectives-banner> <bulk-actions-menu canvas="{this}"></bulk-actions-menu> <undo-banner canvas="{this}" operation="{this.operation}"></undo-banner> <div ref="downloadStatus" class="app-notification" style="display: none;">Your download will begin shortly…</div> <app-notification canvas="{this}"></app-notification> <map-alert canvas="{this}"></map-alert> <connection-error-banners canvas="{this}" operation="{this.operation}" store="{this.store}"></connection-error-banners> </div> <dummy-input></dummy-input> <modal-share canvas="{this}" operation="{operation}" store="{store}"></modal-share> <modal-image canvas="{this}"></modal-image> <modal-intro canvas="{this}" if="{isModalIntroShowing()}"></modal-intro> <modal-templates canvas="{this}"></modal-templates> <modal-import canvas="{this}"></modal-import> <modal-invite canvas="{this}"></modal-invite> <modal-extensions canvas="{this}"></modal-extensions> <gallery canvas="{this}"></gallery> <node-limit-upsell-banner></node-limit-upsell-banner> <modal-checkout if="{window.pageSettings.enableNodeUpsell}" canvas="{this}"></modal-checkout> <modal-checkout-confirmation if="{window.pageSettings.enableNodeUpsell}" canvas="{this}"></modal-checkout-confirmation> <presentation-controls canvas="{this}"></presentation-controls> <div if="{!window.pageSettings.embedded}" class="mobile-banner" ref="mobileBanner"> <h1><i class="fa fa-mobile"></i> Mobile mode is view-only</h1> <div class="buttons"> <a class="button" ref="desktopLink">Go to desktop version</a> </div> </div> <lightbox canvas="{this}"></lightbox> <app-footer canvas="{this}"></app-footer> <export-menu canvas="{this}"></export-menu> <link-direction-menu canvas="{this}"></link-direction-menu> <node-image-menu canvas="{this}"></node-image-menu> <image-size-menu canvas="{this}"></image-size-menu> <waypoints-tab-menu canvas="{this}"></waypoints-tab-menu> <waypoints-tab-item-menu canvas="{this}"></waypoints-tab-item-menu> <site-previwer-menu canvas="{this}"></site-previwer-menu> <perspective-settings-menu canvas="{this}"></perspective-settings-menu> <perspective-settings-text-menu canvas="{this}"></perspective-settings-text-menu> <edit-share-user-access-menu canvas="{this}"></edit-share-user-access-menu> <accept-request-access-menu canvas="{this}"></accept-request-access-menu> <region-shape-menu canvas="{this}"></region-shape-menu> <sidebar if="{isSidebarShowing()}" canvas="{this}"></sidebar> <external-link-popover operation="{this.operation}" canvas="{this}"></external-link-popover> <navigation-switcher if="{!window.pageSettings.hideZoomTools}" canvas="{this}"></navigation-switcher> <zoom-tools if="{!window.pageSettings.hideZoomTools}" canvas="{this}"></zoom-tools> <app-header canvas="{this}" store="{this.store}" operation="{this.operation}"></app-header> <rapid-card-creator show="{this.rapidFireActivated}" canvas="{this}" store="{this.store}"></rapid-card-creator> <tools-sidebar if="{!window.pageSettings.hideToolsSidebar}" canvas="{this}" operation="{this.operation}"></tools-sidebar> <perspectives-listing-item-tool-menu canvas="{this}" operation="{this.operation}"> </perspectives-listing-item-tool-menu> <new-perspective-autocomplete canvas="{this}"></new-perspective-autocomplete> <node-menu canvas="{this}"></node-menu> <link-menu canvas="{this}"></link-menu> <drawing-menu canvas="{this}"></drawing-menu> <node-attribute-editor canvas="{this}"></node-attribute-editor> <toolbar-view-more-menu canvas="{this}"></toolbar-view-more-menu> <right-click-menu canvas="{this}"></right-click-menu> <node-perspectives-panel canvas="{this}" operation="{this.operation}"></node-perspectives-panel> <node-alignment-panel canvas="{this}" operation="{this.operation}"></node-alignment-panel> <node-layout-menu canvas="{this}" operation="{this.operation}"></node-layout-menu> <node-align-content-menu canvas="{this}" operation="{this.operation}"></node-align-content-menu> <perspective-annotation-popover canvas="{this}"></perspective-annotation-popover> <collapsed-card-adoption-popover canvas="{this}"></collapsed-card-adoption-popover> <comment-menu canvas="{this}"></comment-menu> <comment-reaction-menu canvas="{this}"></comment-reaction-menu> <region-menu canvas="{this}"></region-menu> <floating-tooltip canvas="{this}"></floating-tooltip> <div ref="canvas" id="canvas" ref="canvas" class="panzoomable annotations-inset"> <div id="pannable" ref="pannable" class="panzoomable selection-area-enabled" riot-style="{this.getBackgroundStyle()}">></div> <line-creation-tool canvas="{this}"></line-creation-tool> <div id="nodes" ref="nodes"> <links canvas="{this}" operation="{this.operation}"></links> <node-tools canvas="{this}" store="{this.store}" operation="{this.operation}"></node-tools> <div ref="perspectiveDragElement" class="perspective-point-drag-element"> <svg class="perspective-drag-svg"> <path ref="perspectiveDragPath" class="perspective-drag-path eyebeam-path" d="M 0 0"> </svg> </div> <regions canvas="{this}"></regions> <nodes nodes="{this.store.topNodes()}" store="{this.store}" canvas="{this}"></nodes> <drawings canvas="{this}"></drawings> <autocomplete canvas="{this}"></autocomplete> <selection-area getmatrix="{this.getMatrix}" canvas="{this}" store="{this.store}" canvaselement="{this.refs.canvas}"></selection-area> <multi-selection-indicator-box canvas="{this}"></multi-selection-indicator-box> <waypoint-indication-box canvas="{this}"></waypoint-indication-box> <waypoint-selector canvas="{this}" store="{store}"></waypoint-selector> <div ref="dropzone" id="dropzone" class="dropzone"></div> <comments-layer canvas="{this}"></comments-layer> </div> <presence-cursors if="{!pageSettings.disableWebsocket}" canvas="{this}" operation="{operation}"></presence-cursors> </div> <div class="node-listing-item-placeholder" ref="nodeListingItemPlaceholder"></div> <div id="instruction-container" ref="instructionContainer"></div> <node-detail></node-detail> <node-attribute-menu canvas="{this}"></node-attribute-menu> <modal-sign-up if="{showSignupModal()}"></modal-sign-up> <onboarding-popup if="{window.pageSettings.isTryNow && window.user}" canvas="{this}"></onboarding-popup> <text-toolbar canvas="{this}"></text-toolbar> <region-creation-tool></region-creation-tool> <sketchpad canvas="{this}"></sketchpad>',
  '',
  'ref="app"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util.js');

var _constants = require('lib/constants');

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _copyPaste = require('lib/copy-paste');

var _copyPaste2 = _interopRequireDefault(_copyPaste);

var _store2 = require('../store');

var _mousetrap = require('mousetrap');

var _mousetrap2 = _interopRequireDefault(_mousetrap);

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _searchUi = require('lib/search-ui');

var _perspectivesUi = require('lib/perspectives-ui');

var _perspectiveCreationUi = require('lib/perspective-creation-ui');

var _nodesUi = require('lib/nodes-ui');

var _nodeDragUi = require('lib/node-drag-ui');

var _appUi = require('lib/app-ui');

var _sitePreviewUi = require('lib/site-preview-ui');

var _relationshipUi = require('lib/relationship-ui');

var _fileAttachmentsUi = require('lib/file-attachments-ui');

var _attributesUi = require('../lib/node/attributes-ui');

var _dragDrop = require('lib/drag-drop');

var _geom = require('lib/geom');

var _zoomUi = require('lib/zoom-ui');

var _shortcuts = require('lib/shortcuts');

var _globalEventListeners = require('lib/global-event-listeners');

var _mobile = require('lib/mobile');

var _mobile2 = _interopRequireDefault(_mobile);

var _exportScreenshots = require('lib/export-screenshots');

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _presentationUi = require('lib/presentation-ui');

var _presentationUi2 = _interopRequireDefault(_presentationUi);

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _menuUi = require('lib/menu-ui');

var _toolbarUi = require('lib/toolbar-ui');

var _creationToolsUi = require('lib/creation-tools-ui');

var _systemsUi = require('lib/systems-ui');

var _bulkAttributesUi = require('lib/bulk-attributes-ui');

var _upsellUi = require('lib/upsell-ui');

var _historyUi = require('lib/history-ui');

var _selectionUi = require('lib/selection-ui');

var _regionUi = require('lib/region-ui');

var _delayHandler = require('lib/delay-handler');

var _importUi = require('lib/import-ui');

var _linksUi = require('lib/links-ui');

var _collaboratorsUi = require('lib/collaborators-ui');

var _commentsUi = require('lib/comments-ui');

var _drawingUi = require('lib/drawing-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.canvas = this;
this.store = _store_instance2.default;
var self = this;
this.isMac = /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
this.nodes = Array.from(this.opts.store.getNodes());
this.links = this.opts.store.links;
this.operation = this.opts.operation;
this.access = this.store.access;
this.people = this.opts.people;
this.config = this.opts.config;
this.undoBanner = {
  open: false,
  deletedNodeCount: 0,
  deletedLinkCount: 0
};
this.rapidFireActivated = false;
this.selectedElements = [];
this.selectionStash = {};
this.nodeTags = {};
this.linkTags = {};
this.linkEndPointTags = {};
this.nodeAttributeTags = {};
this.childNodeTags = {};
this.commentTags = {};
this.commentTagsInSidebar = {};
this.canvasCommentTags = {};
this.commentContainerTags = {};
this.nodePerspectiveDotTags = {};
this.nodePerspectiveDotsTag = {};
this.nodePerspectiveAnnotationsTag = {};
this.nodePerspectiveAnnotations = {};
this.perspectiveAnnotationTags = {};
this.regionTags = {};
this.drawingTags = {};
this.menuItems = {};
this.menuButtons = {};
this.annotationStyle = _store_instance2.default.getPerspectiveAnnotationStyle();
this.dragDirectionX = 'left';
this.dragDirectionY = 'up';
this.pendingDragDX = 0;
this.pendingDragDY = 0;
this.shift = false;
this.selectedAreaTopLeft = { x: 0, y: 0 };
this.selectedAreaBottomRight = { x: 0, y: 0 };
this.sidebarStatus = 'closed';
this.lastNodeCreatedWithEnterKey = null;
this.hiddenLinks = [];
this.defaultImageSize = 'large';

this.isFirefox = navigator.userAgent.indexOf("Firefox") > 0;
this.isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');

_appUi.appUI.setCanvas(this);
_sitePreviewUi.spUI.setCanvas(this);
_menuUi.mui.setCanvas(this);
_toolbarUi.tui.setCanvas(this);
_creationToolsUi.ctui.setCanvas(this);
_relationshipUi.rui.setCanvas(this);
_perspectivesUi.pui.setCanvas(this);
_perspectiveCreationUi.pcui.setCanvas(this);
_nodesUi.nui.setCanvas(this);
_fileAttachmentsUi.fui.setCanvas(this);
_searchUi.searchUI.setCanvas(this);
_dragDrop.dragdrop.setCanvas(this);
_zoomUi.zoomUI.setCanvas(this);
_exportScreenshots.exportScreenshots.setCanvas(this);
_waypointsUi2.default.setCanvas(this);
_presentationUi2.default.setCanvas(this);
_systemsUi.systemsUI.setCanvas(this);
_bulkAttributesUi.baui.setCanvas(this);
_upsellUi.usui.setCanvas(this);
_historyUi.hui.setCanvas(this);
_selectionUi.selectionUI.setCanvas(this);
_regionUi.regionUI.setCanvas(this);
_importUi.importUI.setCanvas(this);
_nodeDragUi.ndui.setCanvas(this);
_collaboratorsUi.cui.setCanvas(this);
_commentsUi.commentsUI.setCanvas(this);
_drawingUi.drawingUI.setCanvas(this);

document.addEventListener('mouseup', function (e) {
  if (e.target && e.target.focus) {
    e.target.focus();
  }
});

this.isSidebarShowing = function () {
  return !window.pageSettings.hideHelp && _this.sidebarStatus !== 'closed';
};

this.isModalIntroShowing = function () {
  return _this.sidebarStatus === 'user-guide';
};

this.showSignupModal = function () {
  return (window.pageSettings.isTryNow || window.invite) && !window.user;
};

this.getBackgroundStyle = function () {
  var color = _store_instance2.default.getBackgroundColor();
  return 'background: ' + _constants.BACKGROUND_TO_HEX_MAPPING[color];
};

this.updateBackgroundColor = function () {
  _this.refs.app.setAttribute('data-canvas-bg-color', _store_instance2.default.getBackgroundColor());
  _this.refs.pannable.style.background = _constants.BACKGROUND_TO_HEX_MAPPING[_store_instance2.default.getBackgroundColor()];
};

this.initBackgroundColor = function () {
  if (window.user && window.user.settings && window.user.settings.background_color) {
    _store_instance2.default.setBackgroundColor(window.user.settings.background_color);
    _this.updateBackgroundColor();
  }
};

this.rightClickMenuIsOpen = function () {
  return _this.rightClickMenu.summoned || _this.linkMenuTag.summoned;
};

this.hideRightClickMenu = function () {
  if (_this.rightClickMenu.summoned) _this.rightClickMenu.hide();
  if (_this.linkMenuTag.summoned) _this.linkMenuTag.hide();
  if (_this.drawingMenu.summoned) _this.drawingMenu.hide();
};

this.hidePopups = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  //ctui.setActiveTool('pointer');
  if (!_this.externalLinkPopover.hidden) _this.externalLinkPopover.hide();

  if (!_this.autocompleteTag.hidden) _this.autocompleteTag.hide();
  if (_this.introModalTag && _this.introModalTag.showing) _this.introModalTag.hide();
  if (!opts.keepNodeTools) {
    if (!_this.nodeTools.hidden) _this.nodeTools.hide();
  }
  if (_this.creationToolsTag.moreToolsOpen) {
    _this.creationToolsTag.hideMoreTools();
  }
  if (!opts.panzoomStart) {
    if (_this.rightClickMenu.summoned || _this.linkMenuTag.summoned) _this.hideRightClickMenu();
    _this.hideSubmenus();
  }
  if (_this.imageSizeMenu.isOpen) _this.imageSizeMenu.hide();
  if (_this.nodeImageMenu.isOpen) _this.nodeImageMenu.hide();
  if (_this.nodeMenuTag.summoned) _this.nodeMenuTag.hide();
  if (_this.sitePreviewerMenu.isOpen) _this.sitePreviewerMenu.hide();
  if (_this.editShareUserAccessMenu.isOpen) _this.editShareUserAccessMenu.hide();

  if (!opts.keepActiveImage) {
    _this.clearActiveImageNode();
  }

  if (!window.pageSettings.hideMapHeader && !window.pageSettings.hideMapMenu) {
    _this.appHeaderTag.closeMapMenu();
  }
  if (_this.perspectivesListingTag) {
    _this.perspectivesListingTag.stopEditing();
  }
  if (_this.perspectiveSettingsMenu) {
    _this.perspectiveSettingsMenu.hide();
  }
  if (_this.perspectivesListingTag) {
    _waypointsUi2.default.hideTabMenus();
  }
  if (_this.nodeAttributeMenu && _this.nodeAttributeMenu.isOpen) {
    _this.nodeAttributeMenu.hide();
  }

  if (_this.regionMenu && _this.regionMenu.isOpen) {
    _this.regionMenu.hide();
  }

  if (_this.drawingMenu && _this.drawingMenu.summoned) {
    _this.drawingMenu.hide();
  }

  if (_this.attributesTabTag) {
    _this.attributesTabTag.hideMenu();
  }

  if (_this.presence && _this.presence.hideMenu) {
    _this.presence.hideMenu();
  }

  if (_this.bulkActionsMenuTag) {
    _this.bulkActionsMenuTag.clearActiveTools();
  }

  if (_this.newCommentPanel && _this.newCommentPanel.isOpen && !opts.keepNewCommentPanel && !opts.panzoomStart && !opts.panzoomChange) {
    _this.newCommentPanel.hide();
  }

  if (_this.commentMenuTag) {
    _this.commentMenuTag.hide();
  }

  if (_this.commentReactionMenuTag) {
    _this.commentReactionMenuTag.hide();
  }

  if (_this.floatingTooltip) {
    _this.floatingTooltip.hide();
  }

  if (_this.textToolbar && opts.panzoomChange) {
    _this.textToolbar.hide();
  }

  // get all shown comment containers
  var shownCommentContainerNodeIds = Object.keys(_commentsUi.commentsUI._showCommentContainer);

  if (shownCommentContainerNodeIds.length) {
    for (var _iterator = _this.store.comments.map(function (_ref2) {
      var id = _ref2.id;
      return id;
    }), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var commentId = _ref;

      var commentTag = _this.commentTags[commentId];

      if (commentTag && commentTag.isMenuOpen) commentTag.hideMenu();
    }
  }

  // Hide canvas comments
  if (!opts.panzoomStart && !opts.panzoomChange) {
    for (var _iterator2 = shownCommentContainerNodeIds, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var nodeId = _ref3;

      _commentsUi.commentsUI.hideCommentContainer(nodeId);
    }

    var canvasCommentTags = _this.canvasCommentTags;

    for (var id in canvasCommentTags) {
      canvasCommentTags[id].dismiss();
    }

    if (!_commentsUi.commentsUI.showComments()) {
      _this.commentsLayerTag.update();
    }
  }

  if (_this.notificationsTag && _this.notificationsTag.isOpen && !opts.panzoomStart && !opts.panzoomChange) {
    _this.notificationsTag.hideNotifications();
  }
};

this.commentsShown = function () {
  if (_this.newCommentPanel && _this.newCommentPanel.isOpen) return true;

  var shownCommentContainerNodeIds = Object.keys(_commentsUi.commentsUI._showCommentContainer);
  if (shownCommentContainerNodeIds && shownCommentContainerNodeIds.length) return true;
  var canvasCommentTags = _this.canvasCommentTags;

  for (var id in canvasCommentTags) {
    if (canvasCommentTags[id].isShownComment()) {
      return true;
    }
  }
  return false;
};

this.hideSubmenus = function () {
  if (_this.linkDirectionMenu.isOpen) _this.linkDirectionMenu.hide();
  if (_this.nodeAlignmentPanelTag.isOpen) _this.nodeAlignmentPanelTag.hide();
  if (_this.nodePerspectivesPanelTag.isOpen) _this.nodePerspectivesPanelTag.hide();
  if (_this.nodeAttributeEditor.isOpen) _this.nodeAttributeEditor.hide();

  if (_this.nodeLayoutMenuTag.isOpen) _this.nodeLayoutMenuTag.hide();
  if (_this.nodeAlignContentMenuTag.isOpen) _this.nodeAlignContentMenuTag.hide();
  if (_this.exportMenu.isOpen) _this.exportMenu.hide();
  if (_this.toolbarViewMoreMenu.isOpen) _this.toolbarViewMoreMenu.hide();
  if (_this.bulkActionsMenuTag.getRelationshipStylePickerTag() && _this.bulkActionsMenuTag.getRelationshipStylePickerTag().isOpen) _this.bulkActionsMenuTag.getRelationshipStylePickerTag().hideSubMenu();
  if (_this.bulkActionsMenuTag.getCardStylePickerTag() && _this.bulkActionsMenuTag.getCardStylePickerTag().isOpen) _this.bulkActionsMenuTag.getCardStylePickerTag().hideSubMenu();
  if (_this.navigationSwitcher.menuOpen) _this.navigationSwitcher.hideMenu();
  if (_this.regionShapeMenu && _this.regionShapeMenu.isOpen) _this.regionShapeMenu.close();

  _this.bulkActionsMenuTag.resetTools();
};

/* if card is collapsed, show a popover when something gets adopted into it */
this.showCollapsedCardAdoptionPopover = function (_ref4) {
  var parentId = _ref4.parentId,
      count = _ref4.count;

  if (!parentId) return;

  var nodeTag = _this.getNodeTag({ id: parentId });
  if (!nodeTag) return;

  if (nodeTag.instance.getIsCollapsed()) {
    _this.collapsedCardAdoptionPopoverTag.summon({ nodeTag: nodeTag, count: count });
  }
};

this.getNodeTag = function (_ref5) {
  var id = _ref5.id;
  return _this.nodeTags[id];
};

this.getLinkTag = function (_ref6) {
  var id = _ref6.id;
  return _this.linkTags[id];
};

this.setPresentingMode = function () {
  document.body.classList.add('isPresenting');
};

this.unsetPresentingMode = function () {
  document.body.classList.remove('isPresenting');
};

this.setPanzoomOptions = function (options) {
  $(_this.refs.canvas).panzoom('option', options);
};

this.resetPanzoomOptions = function () {
  _this.setPanzoomOptions({ animate: false });
};

this.cancelTransition = function () {
  _this.refs.canvas.style.transition = 'none';
};

this.defocusInput = function () {
  var $focused = $(':focus');
  $focused.blur();
  window.getSelection().removeAllRanges();
};

this.toggleFeature = function (_ref7) {
  var feature = _ref7.feature,
      value = _ref7.value;
  var appHeaderTag = _this.appHeaderTag,
      toolsSidebarTag = _this.toolsSidebarTag;

  window.enabled_features[feature] = value === 1;

  if (appHeaderTag) appHeaderTag.update();
  if (toolsSidebarTag) toolsSidebarTag.update();

  if (feature === 'comments') {
    _commentsUi.commentsUI.freshAllCanvasComments();

    if (_this.sidebarStatus === 'comments') _this.closeSidebar();
  }
};

this.copyNode = function (e) {

  // return if there's any active text selection
  if (window.getSelection().toString().length) {
    return;
  }

  // return if there's a text selection in an input in firefox
  var el = document.activeElement;
  if (el && el.selectionStart !== el.selectionEnd) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  // if text field was in focus, defocus it so we can paste immediately into the map
  if (document.activeElement !== document.body) {
    document.activeElement.blur();
    self.dummyInputTag.focus();
  }

  _copyPaste2.default.copy({ canvas: _this, event: e });
};

this.pasteNode = function (e) {
  if (_this.isViewOnly()) {
    return;
  }
  if (document.activeElement !== document.body && !document.activeElement.classList.contains('dummy-input')) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  var pasteWithinEnabled = false;

  if (_this.shiftKey) {
    pasteWithinEnabled = true;
  }

  if (_upsellUi.usui.userIsOverLimit()) {
    _this.showPaymentModal();
    return;
  }

  // selected any formerly selected items so we can set the pasted elements to selected
  _copyPaste2.default.paste({
    canvas: self,
    pasteWithinEnabled: pasteWithinEnabled,
    position: { x: _this.mouseX, y: _this.mouseY },
    event: e
  });
};

this.dragState = {};

this.on('mount', function () {
  var meta = document.createElement('meta');
  meta.setAttribute("name", "viewport");
  meta.setAttribute("content", "width=1200, initial-scale=0.01, viewport-fit=cover, shrink-to-fit=yes");
  document.head.appendChild(meta);

  _this.initBackgroundColor();

  // strip out desktop dt param if we have it
  var url = new URL(window.location);
  if (url.searchParams.get('dt')) {
    _this.forceDesktop = 1;
    url.searchParams.delete('dt');
    history.replaceState({}, "", url.href);
  }
  url.searchParams.set('dt', 1);
  _this.refs.desktopLink && _this.refs.desktopLink.setAttribute("href", url.href);

  (0, _globalEventListeners.setupGlobalEventListeners)(_this);

  _zoomUi.zoomUI.initializePanZoom();
  _appUi.appUI.initializeTabVisibilityEvents();

  if (document.fonts) {
    document.fonts.ready.then(function () {
      self.realignAllLinks();
    });
  }

  _this.refs.canvas.addEventListener('dblclick', _this.createNodeOnDblClick);

  _this.refs.canvas.addEventListener('contextmenu', _this.summonRightClickMenu);

  var logoutBtn = document.getElementById('header-account-logout-btn');
  if (logoutBtn) {
    logoutBtn.addEventListener('mousedown', function (e) {
      _this.loggingOut = true;
    });
  }

  $('#settings-link').on('click', function (e) {
    e.preventDefault();
    self.openSidebar('user-settings');
  });

  (0, _shortcuts.setupShortcuts)(_this);

  /* fix to prevent panzoom from interfering with placing cursor in title or summary node input */
  $('.handle-input-click-propagation').on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });

  if (!window.pageSettings.hideHelp && !window.pageSettings.isTryNow && !(window.pageSettings.fromSignup && _this.store.getNodesSize() > 0)) {
    if (window.config.openHelpItem || window.user && !window.user.closed_help) {
      if (window.config.openHelpItem == 'keyboard-shortcuts') {
        _this.openSidebar('shortcuts');
      } else {
        _this.openSidebar('user-guide');
        _this.userGuideTag.openItem(window.config.openHelpItem);
      }
    }
    if (window.config.openShareSettings) {
      if (_this.appHeaderTag) {
        _this.appHeaderTag.openShareModal();
        _eventTracking2.default.track({
          category: 'Url-Param',
          action: 'Share-Modal-Shown',
          label: 'Share-Modal-Shown'
        });
      }
    }
  }

  if (!_this.isViewOnly() && window.user && window.pageSettings.isTryNow) {
    _this.templatesModal.show();
  }

  _presentationUi2.default.on('presentation-start', _this.setPresentingMode);
  _presentationUi2.default.on('presentation-resume', _this.setPresentingMode);
  _presentationUi2.default.on('presentation-stop', _this.unsetPresentingMode);
  _presentationUi2.default.on('presentation-pause', _this.unsetPresentingMode);

  _eventTracking2.default.listen(_this.root);

  _commentsUi.commentsUI.initUnseenComments();

  setTimeout(function () {
    // once we send this, if the user leaves the map, they'll see "catch me up" info with all changes since this operation
    // add a delay before we count the latest changes as "seen"
    _historyUi.hui.sendLastOperationSeen();
  }, 10000);
});

this.handleCut = function (e) {
  if (self.isViewOnly()) {
    return;
  }
  // if text field is in focus but no text is selected, copy the node
  if (window.getSelection().toString().length) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  // if text field was in focus, defocus it so we can paste immediately into the map
  if (document.activeElement !== document.body) {
    document.activeElement.blur();
  }

  _copyPaste2.default.copy({ canvas: _this, event: e });
  self.deleteSelectedElements();

  _eventTracking2.default.track({
    category: 'Shortcut',
    action: 'Cut-Selection',
    label: 'Selection'
  });
};

this.operation.on('operation-add-node', function (message) {
  _this.nodesTag.update();
  if (message && message.node) {
    var nodeTag = _this.getNodeTag({ id: message.node.id });
    if (nodeTag) {
      _collaboratorsUi.cui.removeCollaboratorFromField({ user: message.user });
      _collaboratorsUi.cui.setCollaboratorNodeTitleStyle(nodeTag, message.user);
      _this.appFooterTag.update();
    }
  }
});

this.operation.on('operation-toggle-link-preview-hidden', function (message) {
  _sitePreviewUi.spUI.setLinkIsHidden({
    nodeTag: _this.nodeTags[message.nodeId.toString()],
    isHidden: message.isHidden,
    skipOperation: true,
    url: message.url
  });
});

this.operation.on('operation-toggle-link-preview-collapsed', function (message) {
  _sitePreviewUi.spUI.setLinkIsCollapsed({
    nodeTag: _this.nodeTags[message.nodeId.toString()],
    isCollapsed: message.isCollapsed,
    skipOperation: true,
    url: message.url
  });
});

this.operation.on('operation-add-perspective-point', function (message) {
  self.tags['tools-sidebar'].tags['perspectives-listing'].update();
  if (message.pointMapNodeUUID && _this.nodeTags[message.pointMapNodeUUID]) {
    var pointNodeTag = _this.nodeTags[message.pointMapNodeUUID];
    pointNodeTag.freshenEyeball();
    pointNodeTag.updatePerspectiveDots();
    pointNodeTag.topLevelParentTag().rediscoverLinkPositions();
  }
});

this.operation.on('operation-delete-perspective-point', function (message) {
  self.tags['tools-sidebar'].tags['perspectives-listing'].update();
  var perspective = message._deletedPerspective;
  if (perspective) {
    if (_perspectivesUi.pui.perspectiveIsActive(perspective.id)) {
      _perspectivesUi.pui.unsetActivePerspective(perspective);
    }
    if (perspective.pointNodeUUID && _this.nodeTags[perspective.pointNodeUUID]) {
      var pointNodeTag = _this.nodeTags[perspective.pointNodeUUID];
      pointNodeTag.freshenEyeball();
      pointNodeTag.updatePerspectiveDots();
      pointNodeTag.topLevelParentTag().rediscoverLinkPositions();
    }
    var perspectiveNodeTags = _perspectivesUi.pui.getPerspectiveNodeTags(perspective);

    for (var _iterator3 = perspectiveNodeTags, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref8;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref8 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref8 = _i3.value;
      }

      var perspectiveNodeTag = _ref8;

      if (perspectiveNodeTag) {
        perspectiveNodeTag.updatePerspectiveDots();
      }
    }
    _nodesUi.nui.bulkRealignLinks(perspectiveNodeTags);
  }
});
this.operation.on('operation-undelete-perspective-point', function (message) {
  self.tags['tools-sidebar'].tags['perspectives-listing'].update();
  var perspective = message._undeletedPerspective;
  if (perspective && perspective.pointNodeUUID && _this.nodeTags[perspective.pointNodeUUID]) {
    var pointNodeTag = _this.nodeTags[perspective.pointNodeUUID];
    pointNodeTag.freshenEyeball();
    pointNodeTag.updatePerspectiveDots();
    pointNodeTag.topLevelParentTag().rediscoverLinkPositions();
  }
  var perspectiveNodeTags = _perspectivesUi.pui.getPerspectiveNodeTags(perspective);

  for (var _iterator4 = perspectiveNodeTags, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
    var _ref9;

    if (_isArray4) {
      if (_i4 >= _iterator4.length) break;
      _ref9 = _iterator4[_i4++];
    } else {
      _i4 = _iterator4.next();
      if (_i4.done) break;
      _ref9 = _i4.value;
    }

    var perspectiveNodeTag = _ref9;

    if (perspectiveNodeTag) {
      perspectiveNodeTag.updatePerspectiveDots();
    }
  }
  _nodesUi.nui.bulkRealignLinks(perspectiveNodeTags);
});
this.operation.on('operation-update-perspective-point', function (message) {
  var perspective = _store_instance2.default.getPerspective(message.perspectiveUUID);
  _perspectivesUi.pui.updatePerspectiveNodeTags(message.perspectiveUUID);
  _perspectivesUi.pui.refreshPerspectiveLists();
  if (message.prevValues && message.prevValues.pointMapNodeUUID) {
    var nodeTag = _this.nodeTags[message.prevValues.pointMapNodeUUID];
    if (nodeTag) {
      nodeTag.freshenEyeball();
      nodeTag.updatePerspectiveDots();
      nodeTag.refreshPerspectiveHighlight();
      nodeTag.topLevelParentTag().rediscoverLinkPositions();
    }
  }

  if (perspective && perspective.pointNodeUUID) {
    var _nodeTag = _this.nodeTags[perspective.pointNodeUUID];
    if (_nodeTag) {
      _nodeTag.freshenEyeball();
      _nodeTag.updatePerspectiveDots();
      _nodeTag.refreshPerspectiveHighlight();
      _nodeTag.topLevelParentTag().rediscoverLinkPositions();
    }
  }
});
this.operation.on('operation-add-to-perspective-view', function (message) {
  if (message.nodeIds && message.nodeIds.length) {
    for (var _iterator5 = message.nodeIds, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
      var _ref10;

      if (_isArray5) {
        if (_i5 >= _iterator5.length) break;
        _ref10 = _iterator5[_i5++];
      } else {
        _i5 = _iterator5.next();
        if (_i5.done) break;
        _ref10 = _i5.value;
      }

      var id = _ref10;

      self.nodeTags[id].updatePerspectiveDots();
      self.nodeTags[id].topLevelParentTag().rediscoverLinkPositions();
      if (_perspectivesUi.pui.hasPersistentPerspective()) {
        self.nodeTags[id].refreshPerspectiveHighlight();
      }
    }
  }
  if (message.linkIds && message.linkIds.length) {
    if (_perspectivesUi.pui.hasPersistentPerspective()) {
      for (var _iterator6 = message.linkIds, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref11;

        if (_isArray6) {
          if (_i6 >= _iterator6.length) break;
          _ref11 = _iterator6[_i6++];
        } else {
          _i6 = _iterator6.next();
          if (_i6.done) break;
          _ref11 = _i6.value;
        }

        var _id = _ref11;

        self.linkTags[_id].refreshPerspectiveHighlight();
      }
    }
  }
});
this.operation.on('operation-delete-from-perspective-view', function (message) {
  if (message.nodeIds && message.nodeIds.length) {
    for (var _iterator7 = message.nodeIds, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
      var _ref12;

      if (_isArray7) {
        if (_i7 >= _iterator7.length) break;
        _ref12 = _iterator7[_i7++];
      } else {
        _i7 = _iterator7.next();
        if (_i7.done) break;
        _ref12 = _i7.value;
      }

      var id = _ref12;

      self.nodeTags[id].updatePerspectiveDots();
      self.nodeTags[id].topLevelParentTag().rediscoverLinkPositions();
      if (self.nodeTags[id].getPerspectiveAnnotationsTag()) {
        self.nodeTags[id].getPerspectiveAnnotationsTag().removeAnnotation(message.perspectiveUUID);
      }
      if (_perspectivesUi.pui.hasPersistentPerspective()) {
        self.nodeTags[id].refreshPerspectiveHighlight();
      }
    }
  }
  if (message.linkIds && message.linkIds.length) {
    if (_perspectivesUi.pui.hasPersistentPerspective()) {
      for (var _iterator8 = message.linkIds, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref13;

        if (_isArray8) {
          if (_i8 >= _iterator8.length) break;
          _ref13 = _iterator8[_i8++];
        } else {
          _i8 = _iterator8.next();
          if (_i8.done) break;
          _ref13 = _i8.value;
        }

        var _id2 = _ref13;

        self.linkTags[_id2].refreshPerspectiveHighlight();
      }
    }
  }
});
this.operation.on('operation-undelete-from-perspective-view', function (message) {
  if (message.nodeIds && message.nodeIds.length) {
    for (var _iterator9 = message.nodeIds, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
      var _ref14;

      if (_isArray9) {
        if (_i9 >= _iterator9.length) break;
        _ref14 = _iterator9[_i9++];
      } else {
        _i9 = _iterator9.next();
        if (_i9.done) break;
        _ref14 = _i9.value;
      }

      var id = _ref14;

      self.nodeTags[id].updatePerspectiveDots();
      self.nodeTags[id].topLevelParentTag().rediscoverLinkPositions();
      if (_perspectivesUi.pui.hasPersistentPerspective()) {
        self.nodeTags[id].refreshPerspectiveHighlight();
      }
    }
  }
  if (message.linkIds && message.linkIds.length) {
    if (_perspectivesUi.pui.hasPersistentPerspective()) {
      for (var _iterator10 = message.linkIds, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
        var _ref15;

        if (_isArray10) {
          if (_i10 >= _iterator10.length) break;
          _ref15 = _iterator10[_i10++];
        } else {
          _i10 = _iterator10.next();
          if (_i10.done) break;
          _ref15 = _i10.value;
        }

        var _id3 = _ref15;

        self.linkTags[_id3].refreshPerspectiveHighlight();
      }
    }
  }
});
this.operation.on('operation-update-perspective-node-views', function (message) {
  if (message.nodeViews) {
    for (var _iterator11 = message.nodeViews, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
      var _ref16;

      if (_isArray11) {
        if (_i11 >= _iterator11.length) break;
        _ref16 = _iterator11[_i11++];
      } else {
        _i11 = _iterator11.next();
        if (_i11.done) break;
        _ref16 = _i11.value;
      }

      var nodeView = _ref16;

      var nodeTag = _this.nodeTags[nodeView.mapNodeUUID];
      if (nodeTag) {
        nodeTag.updatePerspectiveDots();
      }
    }
  }
});
this.operation.on('operation-edit-perspective-index', function (message) {
  self.tags['tools-sidebar'].tags['perspectives-listing'].update();
  for (var _iterator12 = message.sortedPs, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
    var _ref17;

    if (_isArray12) {
      if (_i12 >= _iterator12.length) break;
      _ref17 = _iterator12[_i12++];
    } else {
      _i12 = _iterator12.next();
      if (_i12.done) break;
      _ref17 = _i12.value;
    }

    var p = _ref17;

    _perspectivesUi.pui.updatePerspectiveNodeTagsDots(p.id);
  }
});

this.operation.on('operation-set-node-perspective-override', function (message) {
  if (message.mapNodeUUID && _this.nodeTags[message.mapNodeUUID]) {
    var nodeTag = _this.nodeTags[message.mapNodeUUID];
    if (message.updates.title !== undefined) {
      nodeTag.updateTitleDisplay(nodeTag.getCurrentTitle());
    }

    if (message.updates.summary !== undefined) {
      nodeTag.updateSummaryDisplay(nodeTag.getCurrentSummary());
    }
  }
});

this.operation.on('operation-create-presentation', function (message) {
  _this.appFooterTag.update();
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-add-presentation-waypoint', function (message) {
  _waypointsUi2.default.refreshRunningPresentation();
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-add-presentation-waypoints', function (message) {
  _waypointsUi2.default.refreshRunningPresentation();
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-remove-presentation-waypoint', function (message) {
  _waypointsUi2.default.stopPresentationIfActiveWaypointMatches(message.waypoint.uuid);
  _waypointsUi2.default.refreshRunningPresentation();
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-remove-presentation-waypoints', function (message) {
  for (var _iterator13 = message.waypoints, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
    var _ref18;

    if (_isArray13) {
      if (_i13 >= _iterator13.length) break;
      _ref18 = _iterator13[_i13++];
    } else {
      _i13 = _iterator13.next();
      if (_i13.done) break;
      _ref18 = _i13.value;
    }

    var waypoint = _ref18;

    _waypointsUi2.default.stopPresentationIfActiveWaypointMatches(waypoint.uuid);
  }
  _waypointsUi2.default.refreshRunningPresentation();
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-clear-presentation-waypoints', function (message) {
  _presentationUi2.default.stop();
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-update-presentation-order-indexes', function (message) {
  _waypointsUi2.default.refreshRunningPresentation();
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-update-presentation-waypoint-title', function (message) {
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-update-presentation-waypoint-node-ids', function (message) {
  _waypointsUi2.default.updateWaypoints();
});

this.operation.on('operation-delete-nodes', function (message) {
  _this.nodesTag.update();
  _this.linksTag.update();
  if (message._localParentIds) {
    for (var _iterator14 = message._localParentIds, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
      var _ref19;

      if (_isArray14) {
        if (_i14 >= _iterator14.length) break;
        _ref19 = _iterator14[_i14++];
      } else {
        _i14 = _iterator14.next();
        if (_i14.done) break;
        _ref19 = _i14.value;
      }

      var nodeId = _ref19;

      if (_this.nodeTags[nodeId]) {
        _this.nodeTags[nodeId].updateTopLevelNeighborsLite();
      }
    }
  }
  if (message._localLinkNodeIds) {
    for (var _iterator15 = message._localLinkNodeIds, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
      var _ref20;

      if (_isArray15) {
        if (_i15 >= _iterator15.length) break;
        _ref20 = _iterator15[_i15++];
      } else {
        _i15 = _iterator15.next();
        if (_i15.done) break;
        _ref20 = _i15.value;
      }

      var _nodeId = _ref20;

      if (_this.nodeTags[_nodeId]) {
        _this.nodeTags[_nodeId].updateTopLevelNeighborsLite();
      }
    }
  }
  _this.removeDeletedFromSelection();
  _this.appFooterTag.update();
  _searchUi.searchUI.refreshResults();
  self.waypointsTabTag && self.waypointsTabTag.refreshIfNeeded();
});
this.operation.on('operation-undelete-nodes', function (message) {
  _this.nodesTag.update();
  _this.linksTag.update();
  for (var _iterator16 = message.undeletedNodeIds, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
    var _ref21;

    if (_isArray16) {
      if (_i16 >= _iterator16.length) break;
      _ref21 = _iterator16[_i16++];
    } else {
      _i16 = _iterator16.next();
      if (_i16.done) break;
      _ref21 = _i16.value;
    }

    var nodeId = _ref21;

    if (_this.nodeTags[nodeId]) {
      _this.nodeTags[nodeId].updateTopLevelNeighborsLite();
    }
  }
  for (var _iterator17 = message.undeletedLinkIds, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
    var _ref22;

    if (_isArray17) {
      if (_i17 >= _iterator17.length) break;
      _ref22 = _iterator17[_i17++];
    } else {
      _i17 = _iterator17.next();
      if (_i17.done) break;
      _ref22 = _i17.value;
    }

    var linkId = _ref22;

    if (_this.linkTags[linkId]) {
      _this.linkTags[linkId].update();
      var link = _store_instance2.default.getLink(linkId);
      if (link.linkNode()) {
        _this.nodeTags[link.linkNodeId].updateTopLevelNeighborsLite();
      }
    }
  }
  _this.appFooterTag.update();
  _searchUi.searchUI.refreshResults();
  self.waypointsTabTag && self.waypointsTabTag.refreshIfNeeded();
});
this.operation.on('operation-delete-link', function (message) {
  if (message.linkId && _store_instance2.default.getLink(message.linkId)) {
    var linkNode = _store_instance2.default.getLink(message.linkId).linkNode();
    if (linkNode && _this.nodeTags[linkNode.id]) {
      _this.nodeTags[linkNode.id].updateTopLevelNeighborsLite();
    }
  }
  _this.linksTag.update();
});
this.operation.on('operation-undelete-link', function (message) {
  _this.linksTag.update();
  if (_this.linkTags[message.linkId]) {
    _this.linkTags[message.linkId].update();
    _this.nodesTag.update();
  }
});
this.operation.on('operation-add-link', function (message) {
  _this.linksTag.update();
  _this.linkTags[message.link.id].update();
});
this.operation.on('operation-set-link-direction', function (message) {
  if (message.linkUUID && _this.linkTags[message.linkUUID]) {
    _this.linkTags[message.linkUUID].updateDirectionState();
  }
});
this.operation.on('operation-set-link-color', function (message) {
  if (message.linkUUID && _this.linkTags[message.linkUUID]) {
    _this.linkTags[message.linkUUID].updateStrokeColor();
    var linkNode = _store_instance2.default.getLink(message.linkUUID).linkNode();
    if (linkNode && _this.nodeTags[linkNode.id]) {
      _this.nodeTags[linkNode.id].update({ forceUpdate: true });
    }
  }
  _this.bulkActionsMenuTag.update();
});
this.operation.on('operation-set-link-type', function (message) {
  if (message.linkUUID && _this.linkTags[message.linkUUID]) {
    _this.linkTags[message.linkUUID].updateStyle();
    var linkNode = _store_instance2.default.getLink(message.linkUUID).linkNode();
    if (linkNode && _this.nodeTags[linkNode.id]) {
      _this.nodeTags[linkNode.id].update({ forceUpdate: true });
    }
  }
  _this.bulkActionsMenuTag.update();
});

this.operation.on('operation-set-link-width', function (message) {
  if (message.linkUUID && _this.linkTags[message.linkUUID]) {
    _this.linkTags[message.linkUUID].updateStyle();
    var linkNode = _store_instance2.default.getLink(message.linkUUID).linkNode();
    if (linkNode && _this.nodeTags[linkNode.id]) {
      _this.nodeTags[linkNode.id].update({ forceUpdate: true });
    }
  }
  _this.bulkActionsMenuTag.update();
});

this.operation.on('operation-set-link-curvature', function (_ref23) {
  var linkUUID = _ref23.linkUUID;
  var linkTags = _this.linkTags;

  if (linkUUID && linkTags[linkUUID]) {
    linkTags[linkUUID].updateCurvature();
  }
});

this.operation.on('operation-set-link-angles', function (message) {
  if (message.linkUUID && _this.linkTags[message.linkUUID]) {
    _this.linkTags[message.linkUUID].updatePosition();
  }
});
this.operation.on('operation-update-link-endpoints', function (message) {
  if (message.linkUUID) {
    _this.linkTags[message.linkUUID].update();

    var link = _store_instance2.default.getLink(message.linkUUID);
    var fromEndPoint = message.fromEndPoint,
        toEndPoint = message.toEndPoint;

    var fromPointX = fromEndPoint.x;
    var fromPointY = fromEndPoint.y;
    var fromNodeEdge = fromEndPoint.nodeEdge;
    var fromPointRelativeX = fromEndPoint.relativeX;
    var fromPointRelativeY = fromEndPoint.relativeY;
    var fromNodeId = fromEndPoint.nodeId;
    var toPointX = toEndPoint.x;
    var toPointY = toEndPoint.y;
    var toNodeEdge = toEndPoint.nodeEdge;
    var toPointRelativeX = toEndPoint.relativeX;
    var toPointRelativeY = toEndPoint.relativeY;
    var toNodeId = toEndPoint.nodeId;

    link.fromNodeId = fromNodeId;
    link.toNodeId = toNodeId;
    link.updateFromEndPoint({
      x: fromPointX,
      y: fromPointY,
      nodeEdge: fromNodeEdge,
      relativeX: fromPointRelativeX,
      relativeY: fromPointRelativeY,
      nodeId: fromNodeId
    });
    link.updateToEndPoint({
      x: toPointX,
      y: toPointY,
      nodeEdge: toNodeEdge,
      relativeX: toPointRelativeX,
      relativeY: toPointRelativeY,
      nodeId: toNodeId
    });

    _this.linkTags[message.linkUUID].updatePosition();
    var _arr = [link.fromNodeId, link.toNodeId];
    for (var _i18 = 0; _i18 < _arr.length; _i18++) {
      var id = _arr[_i18];
      if (id == 0) continue;
      var n = _this.store.getNode(id);
      if (!n || !_this.nodeTags[id]) continue;

      _this.nodeTags[id].placeLinkNodesRecursively(n);
    }

    if (link.fromEndPoint) {
      var endPoint = link.fromEndPoint;
      endPoint.setNodeId(fromNodeId);
      endPoint.updatePosition();
    }
    if (link.toEndPoint) {
      var _endPoint = link.toEndPoint;
      _endPoint.setNodeId(toNodeId);
      _endPoint.updatePosition();
    }

    _this.linkTags[message.linkUUID].updatePosition();
  }
});
this.operation.on('operation-set-link-endpoints', function (message) {
  if (message.linkUUID) {
    var link = _store_instance2.default.getLink(message.linkUUID);
    _this.linkTags[message.linkUUID].updatePosition();
    var _arr2 = [link.fromNode(), link.toNode()];
    for (var _i19 = 0; _i19 < _arr2.length; _i19++) {
      var n = _arr2[_i19];
      _this.nodeTags[n.id].placeLinkNodesRecursively(n);
    }
  }
});
this.operation.on('operation-set-link-node-id', function (message) {
  // update the link node being set
  if (message.link && message.link.linkNodeId && _this.nodeTags[message.link.linkNodeId]) {
    (0, _util.updateDisplayProperties)(message.link.linkNodeId, _this);
    _this.nodeTags[message.link.linkNodeId].topLevelParentTag().rediscoverLinkPositions();
  }
  // and/or update the previous link node
  if (message.prevLink && message.prevLink.linkNodeId && _this.nodeTags[message.prevLink.linkNodeId]) {
    (0, _util.updateDisplayProperties)(message.prevLink.linkNodeId, _this);
    _this.nodeTags[message.prevLink.linkNodeId].topLevelParentTag().rediscoverLinkPositions();
  }

  if (message.link) {
    var linkTag = _this.linkTags[message.link.id];
    if (linkTag) {
      if (message.link.linkNodeId) {
        var box = linkTag.describeArc().outerBox;
        linkTag.setClipPolygon(box);
      } else {
        linkTag.removeClipPolygon();
      }
    }
  }
});
this.operation.on('operation-update-node-justification', function (message) {
  var nodeTag = _this.nodeTags[message.nodeUUID];
  if (nodeTag) {
    nodeTag.update({ forceUpdate: true });
    nodeTag.refreshFreehandAncestors();
  }
});
this.operation.on('operation-update-node-dimensions', function (message) {
  var nodeTag = _this.nodeTags[message.nodeUUID];
  if (nodeTag) {
    nodeTag.update({ forceUpdate: true });
    nodeTag.refreshFreehandAncestors();
  }
});
this.operation.on('operation-update-node-positions', function (message) {
  if (message.selectedNodes) {
    (0, _util.updateSelectedNodeTree)(message.selectedNodes, _this);
  }
  if (message.linkAngles) {
    for (var _iterator18 = message.linkAngles, _isArray18 = Array.isArray(_iterator18), _i20 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();;) {
      var _ref24;

      if (_isArray18) {
        if (_i20 >= _iterator18.length) break;
        _ref24 = _iterator18[_i20++];
      } else {
        _i20 = _iterator18.next();
        if (_i20.done) break;
        _ref24 = _i20.value;
      }

      var linkAngle = _ref24;

      var linkTag = _this.linkTags[linkAngle.uuid];
      if (linkTag) {
        linkTag.updatePosition();
      }
    }
  }
  if (message.nodePositions) {
    var ids = message.nodePositions.map(function (n) {
      return n.uuid;
    });
    for (var _iterator19 = message.nodePositions, _isArray19 = Array.isArray(_iterator19), _i21 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();;) {
      var _ref25;

      if (_isArray19) {
        if (_i21 >= _iterator19.length) break;
        _ref25 = _iterator19[_i21++];
      } else {
        _i21 = _iterator19.next();
        if (_i21.done) break;
        _ref25 = _i21.value;
      }

      var nodePos = _ref25;

      var nodeTag = _this.nodeTags[nodePos.uuid];
      if (nodeTag) {
        nodeTag.updatePosition();
      }
    }
    (0, _util.refreshFreehandAncestorsOfList)(ids, _this, _this.store);
  }

  if (!message.selectedNodes && message.nodePositions) {
    message.selectedNodes = message.nodePositions.map(function (n) {
      return n.uuid;
    });
  }

  if (message.selectedNodes) {
    _nodesUi.nui.bulkRealignLinks(message.selectedNodes.map(function (id) {
      return _this.nodeTags[id];
    }));
  }
});

this.operation.on('operation-set-collapsed-state', function (message) {
  var nodeTag = _this.nodeTags[message.nodeUUID];
  if (nodeTag) {
    nodeTag.updateTopLevelNeighborsLite();
    _searchUi.searchUI.refreshResults();
  }
});
this.operation.on('operation-add-batch', function (message) {
  (0, _util.updatePastedBatchDisplay)({
    nodes: message.nodes,
    links: message.links,
    canvas: _this
  });
  _this.appFooterTag.update();
});
this.operation.on('operation-edit-node', function (message) {

  var nodeTag = _this.nodeTags[message.nodeUUID];
  if (nodeTag) {
    if (message.updates.title !== undefined) {
      var focus = _this.getFocusedElement();
      if (focus && focus.nodeId && focus.nodeId === nodeTag.id && focus.field === 'title') {

        var currentInputText = nodeTag.refs.title.innerText;
        // give user a message if they changed the text; otherwise just update it

        if (nodeTag.initialTitle && currentInputText !== nodeTag.initialTitle) {
          _collaboratorsUi.cui.conjureElementChangedBanner({
            nodeTag: nodeTag,
            field: 'title',
            user: message.user
          });
          return;
        }
      }

      nodeTag.updateTitleDisplay();
    }
    if (message.updates.summary !== undefined) {
      var _focus = _this.getFocusedElement();
      if (_focus && _focus.nodeId && _focus.nodeId === nodeTag.id && _focus.field === 'summary') {

        var _currentInputText = nodeTag.refs.summary.innerText;
        if (nodeTag.initialSummary && _currentInputText !== nodeTag.initialSummary) {
          _collaboratorsUi.cui.conjureElementChangedBanner({
            nodeTag: nodeTag,
            field: 'summary',
            user: message.user
          });
          return;
        }
      }

      nodeTag.updateSummaryDisplay();
    }
    var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(message.nodeUUID);
    if (perspective) {
      _perspectivesUi.pui.refreshPerspectiveLists();
    }
    nodeTag.updateTopLevelNeighborsLite();
    nodeTag.update();
    nodeTag.refs.sitePreviewer && nodeTag.refs.sitePreviewer.update();
    _searchUi.searchUI.refreshResults();
  }
});
this.operation.on('operation-set-children-detached', function (message) {
  var id = message.nodeUUID;
  var nodeTag = _this.nodeTags[id];
  if (id && nodeTag) {
    nodeTag.updateChildDetachment(id);
    if (nodeTag.childNodesTag) {
      nodeTag.childNodesTag.update();
      nodeTag.childNodesTag.updatePosition();
      nodeTag.childNodesTag.updateShadow();
      nodeTag.childNodesTag.enableDragging();
    }
    nodeTag.updateTopLevelNeighborsLite();
  }
  _this.bulkActionsMenuTag.update();
});
this.operation.on('operation-set-node-background-color', function (message) {
  var id = message.nodeUUID;
  var nodeTag = _this.nodeTags[id];
  if (id && nodeTag) {
    nodeTag.updateDescendants();
  }
  _menuUi.mui._updateCardStyleButtons();
});
this.operation.on('operation-set-node-display-style', function (message) {
  var id = message.nodeUUID;
  var nodeTag = _this.nodeTags[id];
  if (id && nodeTag) {
    nodeTag.updateDescendants();
  }
  _menuUi.mui._updateCardStyleButtons();
});
this.operation.on('operation-set-children-position', function (message) {
  var id = message.nodeUUID;
  if (id && _this.nodeTags[id]) {
    var nodeTag = _this.nodeTags[id];
    if (nodeTag.childNodesTag) {
      nodeTag.childNodesTag.updatePosition();
      nodeTag.childNodesTag.updateShadow();
    }

    nodeTag.fitChildNodeContentsAndUpdate(nodeTag.id);
    var ancestors = canvas.store.getNode(nodeTag.id).ancestors();
    for (var _iterator20 = ancestors, _isArray20 = Array.isArray(_iterator20), _i22 = 0, _iterator20 = _isArray20 ? _iterator20 : _iterator20[Symbol.iterator]();;) {
      var _ref26;

      if (_isArray20) {
        if (_i22 >= _iterator20.length) break;
        _ref26 = _iterator20[_i22++];
      } else {
        _i22 = _iterator20.next();
        if (_i22.done) break;
        _ref26 = _i22.value;
      }

      var ancestor = _ref26;

      if (ancestor.getLayoutName() == 'layout-freehand') {
        canvas.nodeTags[ancestor.id].fitChildNodeContentsAndUpdate(ancestor.id);
      }
    }
    nodeTag.topLevelParentTag().rediscoverLinkPositions();
  }
});
this.operation.on('operation-set-layout-name', function (message) {
  if (_this.nodeTags[message.nodeUUID]) {
    if (_this.nodeTags[message.nodeUUID].childNodesTag) {
      _this.nodeTags[message.nodeUUID].childNodesTag.fitToContents();
    }
    _this.nodesTag.update();
    _this.nodeTags[message.nodeUUID].updateTopLevelNeighborsLite();
    _this.nodeTags[message.nodeUUID].topLevelParentTag().rediscoverLinkPositions();
  }
});
this.operation.on('operation-add-file-to-node', function (message) {
  _this.nodeTags[message.nodeUUID].updateLayers();
  _this.nodeTags[message.nodeUUID].updateTopLevelNeighborsLite();
});
this.operation.on('operation-rotate-node-file', function (message) {
  _this.nodeTags[message.nodeUUID].updateLayers();
  _this.nodeTags[message.nodeUUID].updateTopLevelNeighborsLite();
});
this.operation.on('operation-update-node-file', function (message) {
  _this.nodeTags[message.nodeUUID].updateImageStyle();
  _this.nodeTags[message.nodeUUID].updateTopLevelNeighborsLite();
});
this.operation.on('operation-delete-node-file', function (message) {
  _this.nodeTags[message.nodeUUID].updateLayers();
  _this.nodeTags[message.nodeUUID].updateTopLevelNeighborsLite();
});
this.operation.on('operation-undelete-node-file', function (message) {
  _this.nodeTags[message.nodeUUID].updateLayers();
  _this.nodeTags[message.nodeUUID].updateTopLevelNeighborsLite();
  if (_this.imageModal.open) {
    _this.imageModal.show(message.nodeUUID, { edit: true });
  }
});
this.operation.on('operation-add-map-node-attribute', function (message) {
  _bulkAttributesUi.baui.updateNode(message.mapNodeUUID);
  _bulkAttributesUi.baui.updateSidebar();
});
this.operation.on('operation-remove-map-node-attribute', function (message) {
  _bulkAttributesUi.baui.updateNode(message.mapNodeUUID);
  _bulkAttributesUi.baui.updateSidebar();
});
this.operation.on('operation-edit-map-node-attribute', function (message) {
  _bulkAttributesUi.baui.updateNode(message.mapNodeUUID);
  _bulkAttributesUi.baui.updateSidebar();
});
this.operation.on('operation-add-comment', function (message) {
  var comment = _this.store.getComment(message.uuid);
  if (!comment) return;
  if (window.user && comment.userId !== window.user.id) {
    _commentsUi.commentsUI.addUnseenComment(comment.id);
  }
  _commentsUi.commentsUI.freshenComment(comment);
});
this.operation.on('operation-edit-comment', function (message) {
  var comment = _this.store.getComment(message.uuid);
  if (!comment) return;
  _commentsUi.commentsUI.freshenComment(comment);
});
this.operation.on('operation-delete-comment', function (message) {
  var comment = _this.store.getComment(message.uuid);
  if (!comment) return;
  _commentsUi.commentsUI.freshenComment(comment);
});
this.operation.on('operation-undelete-comment', function (message) {
  var comment = _this.store.getComment(message.uuid);
  if (!comment) return;
  _commentsUi.commentsUI.freshenComment(comment);
});
this.operation.on('operation-resolve-comment', function (message) {
  var comment = _this.store.getComment(message.uuid);
  if (!comment) return;
  _commentsUi.commentsUI.freshenComment(comment);
});
this.operation.on('operation-unresolve-comment', function (message) {
  var comment = _this.store.getComment(message.uuid);
  if (!comment) return;
  _commentsUi.commentsUI.freshenComment(comment);
});
this.operation.on('operation-update-comment-display-properties', function (message) {
  var comment = _this.store.getComment(message.uuid);
  if (!comment) return;
  _commentsUi.commentsUI.freshenComment(comment);
});

this.operation.on('operation-update-map-display-properties', function (message) {
  if (message.displayProperties) {
    if (message.displayProperties.annotationStyle) {
      _this.annotationStyle = _store_instance2.default.getPerspectiveAnnotationStyle();
      _this.redrawAnnotations();
    }
  }
});

this.operation.on('operation-add-region', function (message) {
  _this.appFooterTag.update();
  _this.regionsTag.update();
});
this.operation.on('operation-update-region', function (message) {
  if (message.regionUUID) {
    var regionTag = _this.regionTags[message.regionUUID];
    if (message.updates.title !== undefined) {

      /* if we're focused in the title, give the user a prompt if they changed text already */
      var focus = _this.getFocusedElement();
      if (focus && focus.regionId && focus.regionId === regionTag.id) {

        var currentInputText = regionTag.refs.title.innerText;
        if (regionTag.initialTitle && currentInputText !== regionTag.initialTitle) {

          _collaboratorsUi.cui.conjureElementChangedBanner({
            regionTag: regionTag,
            field: 'title',
            user: message.user
          });
          return;
        }
      }

      regionTag.refreshTitle();
    }
    if (message.updates.color) {
      regionTag.refreshColor();
    }
    if (message.updates.top || message.updates.left) {
      regionTag.refreshPosition();
    }
  }
});

this.operation.on('operation-delete-region', function (message) {
  _this.regionsTag.update();
  delete _this.regionTags[message.regionUUID];
});

this.operation.on('operation-add-drawing', function () {
  _this.drawingsTag.update();
});

this.operation.on('operation-update-drawing-display-properties', function (message) {
  var drawing = _this.store.getDrawing(message.uuid);
  if (!drawing) return;
  _this.drawingTags[message.uuid].update();
});

this.operation.on('operation-delete-drawing', function (message) {
  delete _this.drawingTags[message.uuid];
  _this.drawingsTag.update();
});

this.operation.on('operation-update-map-share-settings', function (message) {
  if (message.access && message.access.permission == 'none') {
    window.location.reload();
  }
});

this.operation.on('operation-share-map-with-user', function (message) {
  if (!_this.inviteSharePanel) return;

  if (message.sentToUser) {
    _this.inviteSharePanel.updateSharedWithUsers([message.sentToUser]);
  }
});

this.operation.on('operation-update-user-share-settings', function (message) {
  var permission = message && message.access ? message.access.permission : null;
  if (permission === 'edit' || permission === 'comment' || permission === 'view') {
    if (_this.appHeaderTag) {
      _this.appHeaderTag.update();
    }
  }

  if (message.access && message.access.permission == 'none') {
    window.location.reload();
  }

  // TODO: update other users' share modals
});

this.operation.on('operation-update-map-enabled-feature', this.toggleFeature);

this.operation.on('logged-out', function (message) {
  if (_this.loggingOut) return;
  self.update();
  window.location.href = '/';
});
this.operation.on('disconnected', function (message) {
  console.log('disconnected');
  self.update();
});
this.operation.on('reconnected', function (message) {
  console.log('reconnected');
  self.update();
});

this.operation.on('alert', function (options) {
  return _this.tags['map-alert'].show(options);
});

this.getMatrix = function () {
  return _zoomUi.zoomUI.getMatrix();
};

this.isViewOnly = function () {
  return _this.store.isViewOnly();
};

this.canCommentOnly = function () {
  return _this.store.canCommentOnly();
};

this.openSidebar = function (sidebarType) {
  var prevStatus = _this.sidebarStatus;
  _this.sidebarStatus = sidebarType;
  _this.update();
  _this.sidebarTag.update();
  document.body.classList.add('sidebar-open');

  _this.shiftElements();

  _eventTracking2.default.track({
    category: 'Sidebar',
    action: 'Open-Sidebar',
    label: sidebarType
  });
};

this.openIntroModal = function () {
  _this.introModalTag.show();
};

this.closeSidebar = function () {
  var prevStatus = _this.sidebarStatus;
  _this.sidebarStatus = 'closed';
  document.body.classList.remove('sidebar-open');

  if (window.user && !window.user.closed_help) {
    $.ajax({
      method: 'POST',
      url: '/api/users/display-flags/update',
      data: { closed_help: 1 }
    });
  }
  _this.unShiftElements();
};

this.shiftElements = function () {
  _this.refs.app.classList.add('sidebar-open');
};

this.unShiftElements = function () {
  _this.refs.app.classList.remove('sidebar-open');
  // $('.intercom-messenger-frame').each(function () {
  //   this.style.setProperty('right', '20px', 'important');
  // });

  $(_this.refs.canvas).panzoom('enable');
};

this.disablePanZoom = function () {
  $(self.refs.canvas).panzoom("disable");
};

this.panZoomDisabled = function () {
  return $(self.refs.canvas).panzoom("isDisabled");
};

this.enablePanZoom = function () {
  _zoomUi.zoomUI.unsetPanzoomingFlag();
  $(self.refs.canvas).panzoom("enable");
};

this.handlePaste = function (e) {
  if (self.isViewOnly()) {
    return;
  }

  if (document.activeElement.classList.contains('title') || document.activeElement.classList.contains('summary')) return;

  var clipboardData = void 0;
  if (e.clipboardData) {
    clipboardData = e.clipboardData;
  } else if (e.originalEvent && e.originalEvent.clipboardData) {
    clipboardData = e.originalEvent.clipboardData;
  }
  var isImage = clipboardData && Object.values(clipboardData.items || clipboardData.files).some(function (element) {
    return element.type.indexOf("image") !== -1;
  });

  // only paste image in one card

  if (_this.getSelectedElementIds().length == 1 && isImage && !_this.shiftKey) {
    _this.nodeTags[_this.getSelectedElementIds()[0]].handleFileUpload(e);
  } else {
    _this.pasteNode(e);
  }

  _this.appFooterTag.update();
};

this.handleDelete = function () {
  if (self.isViewOnly()) {
    return;
  }
  // if we're in a text input let that do its thing
  if (document.activeElement.hasAttribute('contenteditable')) return;
  if (_this.linkDragging) return;
  if (Array.from(document.activeElement.classList).includes('new-tag-input')) return;
  if (Array.from(document.activeElement.classList).includes('tag-edit-input')) return;

  if (_this.selectedElements.length < 1 && _regionUi.regionUI.getSelectedRegionIds().size < 1 && _drawingUi.drawingUI.getSelectedDrawingIds().size < 1) return;
  self.deleteSelectedElements();
};

this.deleteNode = function (nodeId) {
  var showUndoBanner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var nodeToDelete = self.store.getNode(nodeId);
  var parent = nodeToDelete.getParent();
  var link = nodeToDelete.link();
  var result = self.store.deleteNodes({ nodeIds: [nodeId] });
  var perspective = _perspectivesUi.pui.getPerspectiveFromPointNode(nodeId);
  var presentation = self.store.getPresentation();
  var presentationUUID = void 0;
  if (presentation) {
    presentationUUID = presentation.id;

    var _presentation$removeN = presentation.removeNodesFromWaypoints({ nodes: [nodeToDelete] }),
        updatedWaypoints = _presentation$removeN.updatedWaypoints,
        removedWaypoints = _presentation$removeN.removedWaypoints;
  }

  var operationMessages = [];

  if (result) {

    _perspectivesUi.pui.deleteElements(result, operationMessages);

    if (parent) {
      if (parent.children() && parent.children().length == 0) {
        parent.setLayoutName('layout-row');
        operationMessages.push(_this.operation.messages.setNodeLayoutName({
          nodeUUID: parent.id,
          prevLayoutName: parent.getLayoutName(),
          layoutName: 'layout-row'
        }));
      }
    }

    if (link && self.linkTags[link.id]) {
      self.linkTags[link.id].removeClipPolygon();
    }

    if (link) {
      operationMessages.push(_this.operation.messages.setLinkNodeId({
        link: link,
        prevLink: link
      }, function (err) {
        console.log('setLinkNodeId failure: ' + err);
      }));
    }

    if (updatedWaypoints && updatedWaypoints.length) {
      for (var _iterator21 = updatedWaypoints, _isArray21 = Array.isArray(_iterator21), _i23 = 0, _iterator21 = _isArray21 ? _iterator21 : _iterator21[Symbol.iterator]();;) {
        var _ref27;

        if (_isArray21) {
          if (_i23 >= _iterator21.length) break;
          _ref27 = _iterator21[_i23++];
        } else {
          _i23 = _iterator21.next();
          if (_i23.done) break;
          _ref27 = _i23.value;
        }

        var updatedWaypoint = _ref27;

        operationMessages.push(_this.operation.messages.updatePresentationWaypointNodeIds({
          presentationUUID: presentationUUID,
          waypointUUID: updatedWaypoint.id,
          nodeIds: updatedWaypoint.nodeIds,
          prevNodeIds: updatedWaypoint.prevNodeIds
        }));
      }
    }

    if (removedWaypoints && removedWaypoints.length) {
      for (var _iterator22 = removedWaypoints, _isArray22 = Array.isArray(_iterator22), _i24 = 0, _iterator22 = _isArray22 ? _iterator22 : _iterator22[Symbol.iterator]();;) {
        var _ref28;

        if (_isArray22) {
          if (_i24 >= _iterator22.length) break;
          _ref28 = _iterator22[_i24++];
        } else {
          _i24 = _iterator22.next();
          if (_i24.done) break;
          _ref28 = _i24.value;
        }

        var waypoint = _ref28;

        operationMessages.push(_this.operation.messages.removePresentationWaypoint({
          presentationUUID: presentationUUID,
          waypoint: waypoint
        }));
      }
    }

    operationMessages.push(_this.operation.messages.deleteNodes({
      nodeIds: [nodeId],
      deletedNodeIds: result.deletedNodeIds || [],
      deletedLinkIds: result.deletedLinkIds || [],
      deletedLinkNodesMap: result.deletedLinkNodesMap || {}
    }, function (err) {
      console.log('deleteNodes failure: ' + err);
    }));

    _this.operation.batchOperation({
      messages: operationMessages,
      onFailure: function onFailure(err) {
        console.warn('deleteNode batchOperation failed: ' + err);
      }
    });
    var deletedElementIds = [].concat(result.deletedNodeIds, result.deletedLinkIds);
    self.selectedElements = self.selectedElements.filter(function (e) {
      return !deletedElementIds.includes(e.instance.id);
    });
  }
  if (nodeToDelete && nodeToDelete.parentId) {
    self.nodeTags[nodeToDelete.parentId].updateTopLevelNeighborsLite();
  }
  _this.nodesTag.update();
  _this.linksTag.update();
  if (parent) {
    _this.nodeTags[parent.id].update();
  }

  _searchUi.searchUI.refreshResults();
  self.waypointsTabTag && self.waypointsTabTag.refreshIfNeeded();
  if (showUndoBanner) {
    _this.openUndoBanner({
      deletedNodeCount: result.deletedNodeIds ? result.deletedNodeIds.length : 0,
      deletedLinkCount: result.deletedLinkIds ? result.deletedLinkIds.length : 0
    });
  }
  if (removedWaypoints && removedWaypoints.length || updatedWaypoints && updatedWaypoints.length) {
    _waypointsUi2.default.updateWaypoints();
  }

  // Update waypoints tab state to show zero states
  if (!_this.nodes.length) {
    if (_waypointsUi2.default.tab) {
      _waypointsUi2.default.tab.update();
    }
  }
  _this.appFooterTag.update();
  if (_this.attributesTabTag) {
    _this.attributesTabTag.update();
  }
};

this.deleteLink = function (linkId) {
  var _self$store$getLink = self.store.getLink(linkId),
      fromNodeId = _self$store$getLink.fromNodeId,
      toNodeId = _self$store$getLink.toNodeId;

  var result = self.store.deleteLink(linkId);
  var removeFromPerspectiveMessages = _perspectivesUi.pui.removeFromAllPerspectives({ linkIds: [linkId] });
  var operationMessages = [];
  if (removeFromPerspectiveMessages) {
    operationMessages = removeFromPerspectiveMessages;
  }
  var message = self.operation.messages.deleteLink({
    linkId: linkId
  });
  operationMessages.push(message);

  _this.operation.batchOperation({
    messages: operationMessages,
    onFailure: function onFailure(err) {
      console.warn('deleteLink batchOperation failed: ' + err);
    }
  });
  _this.update();
  _this.openUndoBanner({ deletedLinkCount: 1 });
};

this.setDragging = function (dragging) {
  if (dragging) {
    _this.dragging = dragging.id;
    if (!dragging.width || !dragging.height) {
      _this.nodeTags[dragging.id].discoverPosition();
    }
    _this.initialDragValues = Object.assign({}, dragging);
    // $('#canvas').addClass('dragging');
  } else {
    _this.dragging = null;
    _this.initialDragValues = {};
    // $('#canvas').removeClass('dragging');
  }
};

this.setNodeDraggingStyle = function () {
  _this.refs.canvas.style.setProperty("cursor", "grabbing", "important");
};

this.unsetNodeDraggingStyle = function () {
  _this.refs.canvas.style.removeProperty("cursor");
};

this.setPendingDragDX = function (dx) {
  _this.pendingDragDX = dx;
};

this.setPendingDragDY = function (dy) {
  _this.pendingDragDY = dy;
};

this.setDragDirectionX = function (direction) {
  _this.dragDirectionX = direction;
};

this.setDragDirectionY = function (direction) {
  _this.dragDirectionY = direction;
};

this.setLinkDragging = function (dragging) {
  _this.linkDragging = dragging;
  if (dragging) {
    _this.refs.canvas.classList.add('link-dragging');
  } else {
    _this.refs.canvas.classList.remove('link-dragging');
    document.body.classList.remove('link-dragging');
  }
};

this.setDragLink = function (_ref29) {
  var fromNodeId = _ref29.fromNodeId,
      fromNodeRect = _ref29.fromNodeRect,
      x = _ref29.x,
      y = _ref29.y;

  var nodeTag = _this.nodeTags[fromNodeId];
  if (!(nodeTag && nodeTag.refs && nodeTag.refs.container)) return;
  var rect = nodeTag.refs.container.getBoundingClientRect();

  var _getMatrix = _this.getMatrix(),
      scale = _getMatrix.scale,
      tx = _getMatrix.tx,
      ty = _getMatrix.ty;

  var left = (rect.left - tx) / scale;
  var top = (rect.top - ty) / scale;

  var bottom = (rect.bottom - ty) / scale;
  var right = (rect.right - tx) / scale;

  var width = (rect.right - rect.left) / scale;
  var height = (rect.bottom - rect.top) / scale;

  var relDragStartPoint = (0, _geom.findRelDragStartPoint)({
    fromNodeRect: fromNodeRect,
    toPoint: { x: x, y: y }
  });

  _this.relDrag = {
    x1: relDragStartPoint.x,
    y1: relDragStartPoint.y,
    x2: x,
    y2: y
  };
};

// gets all "root" selected nodes, i.e., nodes whose parents aren't also selected, that aren't link nodes
this.getRootSelectedNodes = function () {
  var selectedNodes = _this.getSelectedNodes();
  var selectedNodesLookup = {};
  selectedNodes.forEach(function (node) {
    selectedNodesLookup[node.id] = 1;
  });

  return selectedNodes.filter(function (n) {
    return !(n.link() || n.parentId && selectedNodesLookup[n.parentId]);
  });
};

// classifies a selection of nodes according to whether they are all top-level, all share a parent, or are heterogeneous
this.classifySelection = function (nodes) {
  if (nodes.every(function (n) {
    return !n.parentId;
  })) {
    return 'top-level';
  } else if (nodes.every(function (n) {
    return n.parentId === nodes[0].parentId;
  })) {
    return 'shared-parent';
  } else {
    return 'heterogeneous';
  }
};

this.checkSelectionDragLegality = function () {
  var selectedElements = self.selectedElements.filter(function (n) {
    return n.applyMove;
  });
  var selectedElementIds = selectedElements.map(function (e) {
    return e.id;
  });
  var rootSelectedNodes = _this.getRootSelectedNodes();

  return _this.classifySelection(rootSelectedNodes) === 'top-level' || _this.classifySelection(rootSelectedNodes) === 'shared-parent';
};

this.getFocusedElement = function () {
  var activeElement = document.activeElement;

  if (!activeElement || !activeElement.dataset || !(activeElement.dataset.nodeId || activeElement.dataset.regionId)) return;

  var nodeId = activeElement.dataset.nodeId;
  var regionId = activeElement.dataset.regionId;
  var field = void 0;
  if (nodeId) {
    if (activeElement.classList.contains('title')) {
      field = 'title';
    }
    if (activeElement.classList.contains('summary')) {
      field = 'summary';
    }
  } else if (regionId !== undefined) {
    if (activeElement.classList.contains('title')) {
      field = 'title';
    }
  }
  return { nodeId: nodeId, regionId: regionId, field: field };
};

this.clearHoveredNode = function () {
  _delayHandler.delayHandler.clearDelayFor('hoveredNode');

  for (var _iterator23 = Object.values(_this.nodeTags), _isArray23 = Array.isArray(_iterator23), _i25 = 0, _iterator23 = _isArray23 ? _iterator23 : _iterator23[Symbol.iterator]();;) {
    var _ref30;

    if (_isArray23) {
      if (_i25 >= _iterator23.length) break;
      _ref30 = _iterator23[_i25++];
    } else {
      _i25 = _iterator23.next();
      if (_i25.done) break;
      _ref30 = _i25.value;
    }

    var nt = _ref30;

    nt.childNodesTag && nt.childNodesTag.refs.container && nt.childNodesTag.refs.container.classList.remove('collapsed-dropzone');
  }

  if (!_this.hoveredNode) return;
  _dragDrop.dragdrop.hideDropzone(_this.refs.dropzone);
  if (_this.dragging && _this.getNodeTag({ id: _this.dragging })) {
    _this.getNodeTag({ id: _this.dragging }).unsetTransparent();
    if (_this.selectedElements.length) {
      _nodesUi.nui.unsetTransparent({ nodeIds: _this.getSelectedNodes().map(function (n) {
          return n.id;
        }) });
    }
  }
  if (_this.hoveredNode && _this.hoveredNode.refs && _this.hoveredNode.refs.container) {
    _this.hoveredNode.refs.container.classList.remove('top-hover');

    if (_this.hoveredNode.childNodesTag && _this.hoveredNode.childNodesTag.refs.container) {
      _this.hoveredNode.childNodesTag.refs.container.classList.remove('top-hover');
    }
  }
  if (_this.hoveredNode.topNonFreehandParentTag) {
    _this.hoveredNode.topNonFreehandParentTag().rediscoverLinkPositions();
  }
  _this.hoveredNode = null;

  for (var _iterator24 = _this.hiddenLinks, _isArray24 = Array.isArray(_iterator24), _i26 = 0, _iterator24 = _isArray24 ? _iterator24 : _iterator24[Symbol.iterator]();;) {
    var _ref31;

    if (_isArray24) {
      if (_i26 >= _iterator24.length) break;
      _ref31 = _iterator24[_i26++];
    } else {
      _i26 = _iterator24.next();
      if (_i26.done) break;
      _ref31 = _i26.value;
    }

    var hiddenLinkId = _ref31;

    _this.linkTags[hiddenLinkId].unHide();
  }

  _this.hiddenLinks = [];
};

this.setHoveredNode = function (_ref32, draggingRect, clearHoveredState) {
  var nodeTag = _ref32.nodeTag,
      placement = _ref32.placement;

  // add a delay before we trigger the node hover stuff
  if (_this.hoveredNode && nodeTag && _this.hoveredNode.id === nodeTag.id && _this.hoveredNode.layoutName == 'layout-freehand') {
    _dragDrop.dragdrop.showLastDropzone();
    return;
  }
  // if we just started hovering, do nothing until the timeout kicks in
  if (_delayHandler.delayHandler.isDelayed('hoveredNode', nodeTag.id)) {
    return;
  }
  // if the timeout has been triggered, trigger hover as usual
  if (_delayHandler.delayHandler.isTriggered('hoveredNode', nodeTag.id)) {
    return _this._setHoveredNode({ nodeTag: nodeTag, placement: placement }, draggingRect);
  }

  _delayHandler.delayHandler.initializeDelay({
    action: 'hoveredNode',
    id: nodeTag.id,
    delay: 100,
    callback: function callback() {
      if (clearHoveredState) {
        _this.clearHoveredNode();
        _this.clearHoveredLink();
      }
      _this._setHoveredNode({ nodeTag: nodeTag, placement: placement }, draggingRect);
    }
  });
};

this._setHoveredNode = function (_ref33, draggingRect) {
  var nodeTag = _ref33.nodeTag,
      placement = _ref33.placement;

  if (_this.nodeMenuTag.summoned) return;
  if (_this.rightClickMenuIsOpen()) return;
  //if (this.hoveredNode === nodeTag) return;
  var sameHoveredNode = _this.hoveredNode && _this.hoveredNode.id === nodeTag.id;
  _this.hoveredNode = nodeTag;
  if (nodeTag && _this.dragging && placement) {

    _dragDrop.dragdrop.showDropzone({
      initialDragValues: draggingRect,
      placement: placement,
      dropzone: _this.refs.dropzone,
      targetTag: nodeTag
    });

    if (_this.dragging && _this.getNodeTag({ id: _this.dragging })) {
      _this.getNodeTag({ id: _this.dragging }).setTransparent();

      if (_this.selectedElements.length) {

        _nodesUi.nui.setTransparent({ nodeIds: _this.getSelectedNodes().map(function (n) {
            return n.id;
          }) });
      }
    }
    if (!sameHoveredNode) {
      if (_this.hoveredNode.topNonFreehandParentTag) {
        _this.hoveredNode.topNonFreehandParentTag().rediscoverLinkPositions();
      }

      for (var _iterator25 = nodeTag.instance.links(), _isArray25 = Array.isArray(_iterator25), _i27 = 0, _iterator25 = _isArray25 ? _iterator25 : _iterator25[Symbol.iterator]();;) {
        var _ref34;

        if (_isArray25) {
          if (_i27 >= _iterator25.length) break;
          _ref34 = _iterator25[_i27++];
        } else {
          _i27 = _iterator25.next();
          if (_i27.done) break;
          _ref34 = _i27.value;
        }

        var link = _ref34;

        if (!link.fromNode() || !link.toNode()) continue;

        var endpointAncestorIds = link.fromNode().getLineage().concat(link.toNode().getLineage()).map(function (n) {
          return n.id;
        });
        if (_this.dragging && endpointAncestorIds.includes(_this.dragging)) {

          // hide arcs if they are going to be huge circles (straight very short lines with a large arc flag)
          if (Math.abs(link.angleStartToR) < Math.PI / 8 || Math.abs(link.angleEndToR) < Math.PI / 8) {
            _this.linkTags[link.id].hide();
            _this.hiddenLinks.push(link.id);
          }
        }
      }
    }
  }
};

this.setHoveredLink = function (_ref35, draggingRect) {
  var linkTag = _ref35.linkTag;

  if (_this.dragging && linkTag.instance) {
    /* no dropzone or hover effect if target link isn't a valid spot for the dragged node to be a link node */
    if (!linkTag.instance.isValidLinkNodeId(_this.dragging)) {
      return;
    }
  }

  var sameHoveredLink = _this.hoveredLink && _this.hoveredLink.id === linkTag.id;
  _this.clearHoveredNode();
  if (!sameHoveredLink) {
    _this.clearHoveredLink();
  }

  _this.hoveredLink = linkTag;

  if (!linkTag || !_this.dragging || linkTag.instance.linkNode()) return;

  linkTag.refs.container.classList.add('expanded');

  if (_delayHandler.delayHandler.isDelayed('hoveredNode', linkTag.id)) {
    return;
  }

  // if the timeout has been triggered, trigger hover as usual
  if (_delayHandler.delayHandler.isTriggered('hoveredNode', linkTag.id)) {
    return _this._setHoveredLink({ linkTag: linkTag }, draggingRect);
  }

  _delayHandler.delayHandler.initializeDelay({
    action: 'hoveredNode',
    id: linkTag.id,
    delay: 100,
    callback: function callback() {
      if (!sameHoveredLink) {
        _this.clearHoveredLink();
      }
      linkTag.refs.container.classList.add('expanded');
      _this._setHoveredLink({ linkTag: linkTag }, draggingRect);
    }
  });
};

this._setHoveredLink = function (_ref36, draggingRect) {
  var linkTag = _ref36.linkTag;

  _dragDrop.dragdrop.showLinkDropzone({
    initialDragValues: draggingRect,
    dropzone: _this.refs.dropzone,
    linkTag: linkTag
  });

  if (_this.dragging && _this.getNodeTag({ id: _this.dragging })) {
    _this.getNodeTag({ id: _this.dragging }).setTransparent();
  }
};

this.clearHoveredLink = function () {
  _delayHandler.delayHandler.clearDelayFor('hoveredNode');
  _dragDrop.dragdrop.hideDropzone(_this.refs.dropzone);
  if (_this.dragging && _this.getNodeTag({ id: _this.dragging })) {
    _this.getNodeTag({ id: _this.dragging }).unsetTransparent();
    if (_this.selectedElements.length) {
      _nodesUi.nui.unsetTransparent({ nodeIds: _this.getSelectedNodes().map(function (n) {
          return n.id;
        }) });
    }
  }
  if (!_this.hoveredLink) {
    return;
  }
  _this.hoveredLink.setClipPolygon();
  _this.hoveredLink.refs.container.classList.remove('expanded');
  _this.hoveredLink = null;
};

this.setHoveredImageNode = function (nodeTag) {
  _this.clearHoveredImageNode();
  _this.hoveredImageNodeTag = nodeTag;
  if (nodeTag && nodeTag.refs.nodeResizeHandle) {
    nodeTag.refs.nodeResizeHandle.classList.remove('ready');
  }
};

this.clearHoveredImageNode = function () {
  if (_this.hoveredImageNodeTag && _this.hoveredImageNodeTag.refs.nodeResizeHandle) {
    _this.hoveredImageNodeTag.refs.nodeResizeHandle.classList.add('ready');
  }
  _this.hoveredImageNodeTag = null;
};

this.setActiveImageNode = function (nodeTag) {
  _this.clearActiveImageNode();
  _this.activeImageNodeTag = nodeTag;

  if (nodeTag && nodeTag.refs && nodeTag.refs.imageResizeHandle) {
    nodeTag.refs.imageResizeHandle.classList.add('ready');
    nodeTag.refs.image.classList.add('resizing');
  }
};

this.clearActiveImageNode = function () {
  if (_this.activeImageNodeTag) {
    _this.activeImageNodeTag.refs.imageResizeHandle.classList.remove('ready');
    _this.activeImageNodeTag.refs.image.classList.remove('resizing');
  }
  _this.activeImageNodeTag = null;
};

this.setMouseEnteredPopout = function (childNodeTag) {
  if (_this.rightClickMenuIsOpen()) return;
  if (!childNodeTag.parent.instance.getChildrenDetached()) return;

  _this.clearMouseEnteredNode();

  if (childNodeTag) {
    _this.mouseEnteredNode = childNodeTag.parent;
    if (childNodeTag.refs) {
      childNodeTag.refs.container.classList.add('top-hover');
    }
  }

  // this.refs.canvas.classList.add('node-hovered');
};

this.setMouseEnteredNode = function (nodeTag) {
  if (_this.activeToolName == 'relationship-tool') {
    _this.mouseEnteredNode = nodeTag;
    return;
  }
  if (_this.nodeMenuTag.summoned) return;
  if (_this.rightClickMenuIsOpen()) return;

  if (_this.mouseEnteredNode && _this.mouseEnteredNode.refs && _this.mouseEnteredNode.refs.container) {
    _this.unsetTopHoveredParent(_this.mouseEnteredNode);
    _this.mouseEnteredNode.refs.container.classList.remove('top-hover');
    if (_this.mouseEnteredNode.refs.nodeTopLine) {
      _this.mouseEnteredNode.refs.nodeTopLine.classList.remove('node-top-line-top-hover');
    }

    if (_this.mouseEnteredNode.childNodesTag && _this.mouseEnteredNode.childNodesTag.refs && _this.mouseEnteredNode.childNodesTag.refs.container) {
      _this.mouseEnteredNode.childNodesTag.refs.container.classList.remove('top-hover');
    }
  }
  _this.mouseEnteredNode = nodeTag;
  if (_this.mouseEnteredNode && _this.mouseEnteredNode.refs && _this.mouseEnteredNode.refs.container) {
    _this.mouseEnteredNode.refs.container.classList.add('top-hover');
  }
  if (_this.mouseEnteredNode.refs.nodeTopLine) {
    _this.mouseEnteredNode.refs.nodeTopLine.classList.add('node-top-line-top-hover');
  }
  _this.setTopHoveredParent(_this.mouseEnteredNode);
  // this.refs.canvas.classList.add('node-hovered');
};

this.setTopHoveredParent = function (nodeTag) {
  var topParent = nodeTag.topLevelParentTag();
  if (topParent && topParent.refs && topParent.refs.container) {
    topParent.refs.container.classList.add('top-hover-parent');
  }
};
this.unsetTopHoveredParent = function (nodeTag) {
  var topParent = nodeTag.topLevelParentTag();
  if (topParent && topParent.refs && topParent.refs.container) {
    topParent.refs.container.classList.remove('top-hover-parent');
  }
};

this.clearMouseEnteredNode = function () {
  if (_this.mouseEnteredNode && _this.mouseEnteredNode.refs.container) {
    _this.mouseEnteredNode.refs.container.classList.remove('top-hover');
    if (_this.mouseEnteredNode.refs.nodeTopLine) {
      _this.mouseEnteredNode.refs.nodeTopLine.classList.remove('node-top-line-top-hover');
    }
    if (_this.mouseEnteredNode.childNodesTag && _this.mouseEnteredNode.childNodesTag.refs && _this.mouseEnteredNode.childNodesTag.refs.container) {
      _this.mouseEnteredNode.childNodesTag.refs.container.classList.remove('top-hover');
    }
    _this.unsetTopHoveredParent(_this.mouseEnteredNode);
  }
  _this.mouseEnteredNode = null;
  // this.refs.canvas.classList.remove('node-hovered');
};

this.setDragEnteredNode = function (nodeTag) {
  if (_this.resizeDragging) return;
  if (_this.dragState && _this.dragState.draggingComponentId && _this.dragState.draggingComponentId.includes('region')) return;

  if (_this.dragEnteredNode && _this.dragEnteredNode.instance instanceof _store2.Node && _this.dragEnteredNode.refs.container) {
    _this.dragEnteredNode.refs.container.classList.remove('top-hover');
    _this.dragEnteredNode.refs.nodeTopLine.classList.remove('node-top-line-top-hover');
    _this.dragEnteredNode.refs.container.classList.remove('drag-enter-hover');
  }
  _this.dragEnteredNode = nodeTag;
  if (nodeTag) {
    _this.dragEnteredNode.refs.container.classList.add('top-hover');
    _this.dragEnteredNode.refs.nodeTopLine.classList.add('node-top-line-top-hover');
    _this.dragEnteredNode.refs.container.classList.add('drag-enter-hover');
    _this.dragEnteredNode.topNonFreehandParentTag().rediscoverLinkPositions();
  }
};

this.setValidFreehandDropTargets = function (validFreehandDropTargets) {
  _this.validFreehandDropTargets = validFreehandDropTargets;
};

this.clearSelectedElement = function (tag, opts) {
  if (_this.nodeTags[tag.id]) {
    _this.nodeTags[tag.id].unsetSelected();
  } else if (_this.linkTags[tag.id]) {
    _this.linkTags[tag.id].unsetSelected();
  }
  delete _this.selectionStash[tag.id];
  _this.selectedElements = _this.selectedElements.filter(function (n) {
    return n.id != tag.id;
  });
  if (!opts || !opts.noUpdateSelectedState) {
    _this.updateSelectedState();
  }
};

this.clearSelectedElements = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _this.clearStashedSelection();

  if (_this.selectedElements && _this.selectedElements.length) {
    for (var _iterator26 = _this.selectedElements, _isArray26 = Array.isArray(_iterator26), _i28 = 0, _iterator26 = _isArray26 ? _iterator26 : _iterator26[Symbol.iterator]();;) {
      var _ref37;

      if (_isArray26) {
        if (_i28 >= _iterator26.length) break;
        _ref37 = _iterator26[_i28++];
      } else {
        _i28 = _iterator26.next();
        if (_i28.done) break;
        _ref37 = _i28.value;
      }

      var tag = _ref37;

      _this.clearSelectedElement(tag, { noUpdateSelectedState: true });
    }
    _this.updateSelectedState();
  }
  _this.selectedElements = [];

  if (!opts.dontClearRegions) _regionUi.regionUI.clearSelectedRegions();

  if (!opts.dontClearDrawings) _drawingUi.drawingUI.clearSelectedDrawings();
};

this.setSelectedElements = function (elementTags, shiftKey) {
  if (!shiftKey) {
    _this.clearSelectedElements();
  }
  var newlySelected = [];
  for (var _iterator27 = elementTags, _isArray27 = Array.isArray(_iterator27), _i29 = 0, _iterator27 = _isArray27 ? _iterator27 : _iterator27[Symbol.iterator]();;) {
    var _ref38;

    if (_isArray27) {
      if (_i29 >= _iterator27.length) break;
      _ref38 = _iterator27[_i29++];
    } else {
      _i29 = _iterator27.next();
      if (_i29.done) break;
      _ref38 = _i29.value;
    }

    var elementTag = _ref38;

    if (!_this.isSelectedElement(elementTag.id)) {
      _this.selectedElements.push(elementTag);
      newlySelected.push(elementTag);
    }
  }
  for (var _iterator28 = newlySelected, _isArray28 = Array.isArray(_iterator28), _i30 = 0, _iterator28 = _isArray28 ? _iterator28 : _iterator28[Symbol.iterator]();;) {
    var _ref39;

    if (_isArray28) {
      if (_i30 >= _iterator28.length) break;
      _ref39 = _iterator28[_i30++];
    } else {
      _i30 = _iterator28.next();
      if (_i30.done) break;
      _ref39 = _i30.value;
    }

    var _elementTag = _ref39;

    _elementTag.setSelected();
  }
  _this.updateSelectedState();
};

this.setSelectedElement = function (elementTag, shiftKey) {
  if (!shiftKey || !elementTag) {
    _this.clearSelectedElements();
  }
  var originalLength = _this.selectedElements.length;
  if (elementTag) {
    if (!_this.isSelectedElement(elementTag.id)) {
      _this.selectedElements.push(elementTag);
      elementTag.setSelected();
      if (_this.selectedElements.length == 1 && elementTag.instance instanceof _store2.Link) {
        var link = elementTag.instance;
        _this.selectedLink = link;
        var fromEndPointTag = _this.linkEndPointTags[link.getFromEndPoint().id];
        var toEndPointTag = _this.linkEndPointTags[link.getToEndPoint().id];
        fromEndPointTag.show();
        toEndPointTag.show();
      } else if (_this.selectedLink) {
        _this.clearSelectedLink();
      }
      if (originalLength == 1 && _this.selectedElements.length > 1) {
        _this.selectedElements.forEach(function (element) {
          // unexpand single selection when we select > 1 element
          if (element.instance instanceof _store2.Node) {
            element.updateSelectedState();
            element.updateTopLevelNeighborsLite();
          }
        });
      }
    }
  }
  _this.updateSelectedState();
};

this.clearSelectedLink = function () {
  if (_this.selectedLink) {
    var link = _store_instance2.default.getLink(_this.selectedLink.id);
    _this.selectedLink = null;
    if (link) {
      var fromEndPointTag = _this.linkEndPointTags[link.getFromEndPoint().id];
      var toEndPointTag = _this.linkEndPointTags[link.getToEndPoint().id];
      fromEndPointTag.hide();
      toEndPointTag.hide();
    }
  }
};

this.updateSelectedState = function () {
  var canvas = _this.refs.canvas;

  if (_this.getSelectedElementsCount()) {
    if (!canvas.classList.contains('elements-selected')) {
      canvas.classList.add('elements-selected');
    }
  } else {
    _this.clearSelectedLink();
    if (canvas.classList.contains('elements-selected')) {
      canvas.classList.remove('elements-selected');
    }
  }

  _this.debouncedUpdateToolbar();
  _this.multiSelectionIndicatorBox.update();
};

this.debouncedUpdateToolbar = function () {
  _this.bulkActionsMenuTag.update();
};

this.debouncedUpdateToolbar = (0, _lodash2.default)(this.debouncedUpdateToolbar);

this.toggleSelectedElement = function (elementTag, shiftKey) {
  _creationToolsUi.ctui.setActiveTool('pointer');
  if (_this.isSelectedElement(elementTag.id)) {
    _this.clearSelectedElement(elementTag);
  } else {
    _this.setSelectedElement(elementTag, shiftKey);
  }
};

this.stashCurrentSelection = function () {
  var ids = _this.getSelectedElementIds();
  var regionIds = _regionUi.regionUI.getSelectedRegionIds();
  ids.concat(Array.from(regionIds)).forEach(function (id) {
    _this.selectionStash[id] = 1;
  });
};

this.getStashedSelection = function () {
  return _this.selectionStash;
};

this.clearStashedSelection = function () {
  _this.selectionStash = {};
};

this.getHoveredNode = function () {
  return _this.hoveredNode;
};

this.isSelectedElement = function (id) {
  var element = _this.selectedElements.find(function (el) {
    return el.id == id;
  });
  if (element) {
    return true;
  }
  return false;
};

this.getSelectedElementIds = function () {
  return _this.selectedElements.map(function (el) {
    return el.id;
  });
};

this.updateNodeTag = function (nodeId) {
  if (!nodeId || !_this.nodeTags[nodeId]) {
    return;
  }
  _this.nodeTags[nodeId].update();
};

this.createNodeOnDblClick = function (e, link, broadcastOperation) {
  if (_this.hoveredNode && !link) {
    return;
  }
  if (_this.isViewOnly()) {
    return;
  }

  if (_upsellUi.usui.userIsOverLimit()) {
    _this.showPaymentModal();
    return;
  }

  _this.lastNodeCreatedWithEnterKey = null;

  var _getMatrix2 = _this.getMatrix(),
      scale = _getMatrix2.scale,
      tx = _getMatrix2.tx,
      ty = _getMatrix2.ty;

  var _ref40 = _this.createNewNode({
    x: (e.clientX - tx - 64 * scale) / scale,
    y: (e.clientY - ty - 24 * scale) / scale,
    displayStyle: !!link ? 'transparent' : null
  }, link, broadcastOperation) || {},
      nodeTag = _ref40.nodeTag,
      messages = _ref40.messages;

  _this.appFooterTag.updateStyle();
  _this.onboardingPopupTag && _this.onboardingPopupTag.completeStep('create-card');

  return { nodeTag: nodeTag, messages: messages };
};

this.showPaymentModal = function () {
  _this.modalCheckout.show();
};

this.hidePaymentModal = function () {
  _this.modalCheckout.hide();
};

this.showPaymentConfirmationModal = function (_ref41) {
  var orderKey = _ref41.orderKey,
      planId = _ref41.planId;

  _this.modalConfirmation.show({ orderKey: orderKey, planId: planId });
};

this.hidePaymentConfirmationModal = function () {
  _this.modalConfirmation.hide();
};

this.refreshNewTopLevelNode = function () {
  _this.nodesTag.update();
};

this.createNewNode = function (_ref42, link) {
  var x = _ref42.x,
      y = _ref42.y,
      _ref42$displayStyle = _ref42.displayStyle,
      displayStyle = _ref42$displayStyle === undefined ? null : _ref42$displayStyle,
      _ref42$fromShortcut = _ref42.fromShortcut,
      fromShortcut = _ref42$fromShortcut === undefined ? false : _ref42$fromShortcut,
      _ref42$fileEvent = _ref42.fileEvent,
      fileEvent = _ref42$fileEvent === undefined ? null : _ref42$fileEvent,
      _ref42$cardless = _ref42.cardless,
      cardless = _ref42$cardless === undefined ? false : _ref42$cardless;
  var broadcastOperation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (_upsellUi.usui.userIsOverLimit()) {
    _this.showPaymentModal();
    return;
  }

  var nodeId = _store_instance2.default.addNode({
    x: x,
    y: y,
    title: '',
    summary: "",
    displayStyle: displayStyle,
    createdById: window.user_id, // TODO fix
    orderIndex: 0,
    isNewNode: true,
    cardless: cardless
  });
  var prevLink = Object.assign({}, link);
  if (link) {
    link.setLinkNodeId(nodeId);
    link.setAngles({ lNodePoint: { x: x, y: y } });
    link.placeLinkNode();
  }

  self.refreshNewTopLevelNode();

  var messages = [self.operation.messages.addNode({
    node: _store_instance2.default.getNode(nodeId)
  })];

  if (link) {
    messages.push(self.operation.messages.setLinkNodeId({ link: link, prevLink: prevLink }));

    messages.push(self.operation.messages.setLinkAngles({
      linkUUID: link.id,
      angleStartToR: link.angleStartToR,
      angleEndToR: link.angleEndToR,
      prevAngleStartToR: prevLink.angleStartToR,
      prevAngleEndToR: prevLink.angleEndToR,
      onFailure: function onFailure(err) {
        console.log('setLinkAngles failure: ' + err);
      }
    }));
  }

  var nodeTag = _this.nodeTags[nodeId];
  _perspectivesUi.pui.addNodeToActivePerspectives(nodeTag, messages);

  var allowedDirections = ['left', 'right', 'down', 'up'];
  if (fromShortcut) allowedDirections = ['up'];

  var overlaps = _nodesUi.nui.fixOverlaps({
    nodeTag: nodeTag,
    allowedDirections: allowedDirections
  });

  var prevNodePositions = [];
  var nodePositions = [];
  if (overlaps) {
    nodePositions = overlaps.nodePositions;
    prevNodePositions = overlaps.prevNodePositions;
  }

  if (nodePositions.length) {
    messages.push(self.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  if (broadcastOperation) {
    self.operation.batchOperation({
      messages: messages,
      userId: window.user_id,
      onFailure: function onFailure(err) {
        console.log('createNewNode batchOperation failure: ' + err);
      }
    });
  }

  if (!window.pageSettings.hideMapHeader && !window.pageSettings.hideMapMenu) {
    _this.appHeaderTag.setDidAddNode();
    _this.appHeaderTag.update();
  }

  nodeTag.focusTitle(true, true);

  if (fileEvent) {
    nodeTag.handleFileUpload(fileEvent);
  }

  if (link && self.linkTags[link.id]) {
    self.linkTags[link.id].update();
  }
  _appUi.appUI.zoomToCardIfZoomedOut(nodeTag);

  if (_store_instance2.default.getNodesSize() == 1) {
    _this.waypointsTabTag && _this.waypointsTabTag.refreshIfNeeded();
  }

  return { nodeTag: nodeTag, messages: messages };
};

this.getSelectedElements = function () {
  var nodes = [];
  var links = [];
  self.selectedElements.forEach(function (element) {
    var instance = element.instance;
    if (instance instanceof _store2.Node) {
      nodes.push(instance);
    } else if (instance instanceof _store2.Link) {
      links.push(instance);
    }
  });
  return { nodes: nodes, links: links };
};

this.getSelectedElementsCount = function () {
  return _this.selectedElements.length + _regionUi.regionUI.getSelectedRegions().length + _drawingUi.drawingUI.getSelectedDrawings().length;
};

this.getSelectedNodes = function () {
  var nodes = [];
  self.selectedElements.forEach(function (element) {

    if (element.instance instanceof _store2.Node) {
      var node = _store_instance2.default.getNode(element.instance.id);
      if (node) {
        nodes.push(node);
      }
    }
  });
  return nodes;
};

this.getSelectedLinks = function () {
  var links = [];
  self.selectedElements.forEach(function (element) {
    if (element.instance instanceof _store2.Link) {
      var link = _store_instance2.default.getLink(element.instance.id);
      if (link) {
        links.push(link);
      }
    }
  });
  return links;
};

this.removeDeletedFromSelection = function () {
  _this.selectedElements = _this.selectedElements.filter(function (element) {
    return _store_instance2.default.getNode(element.id) || _store_instance2.default.getLink(element.id);
  });
  _this.bulkActionsMenuTag.update();
};

this.deleteSelectedElements = function () {
  var nodes = self.selectedElements.filter(function (el) {
    return el.instance instanceof _store2.Node;
  });
  var nodeIds = nodes.map(function (n) {
    return n.id;
  });
  var linkIds = self.selectedElements.filter(function (el) {
    return el.instance instanceof _store2.Link;
  }).map(function (n) {
    return n.id;
  });

  for (var _iterator29 = nodeIds, _isArray29 = Array.isArray(_iterator29), _i31 = 0, _iterator29 = _isArray29 ? _iterator29 : _iterator29[Symbol.iterator]();;) {
    var _ref43;

    if (_isArray29) {
      if (_i31 >= _iterator29.length) break;
      _ref43 = _iterator29[_i31++];
    } else {
      _i31 = _iterator29.next();
      if (_i31.done) break;
      _ref43 = _i31.value;
    }

    var nodeId = _ref43;

    var node = _store_instance2.default.getNode(nodeId);
    if (node.link()) {
      _this.linkTags[node.link().id].removeClipPolygon();
    }
  }
  // get all impacted parent ids
  var topLevelParentIds = _nodesUi.nui.getSharedParentIds({ nodeIds: nodeIds });

  var presentation = self.store.getPresentation();
  var presentationUUID = void 0;
  if (presentation) {
    presentationUUID = presentation.id;

    var _presentation$removeN2 = presentation.removeNodesFromWaypoints({ nodes: nodes }),
        updatedWaypoints = _presentation$removeN2.updatedWaypoints,
        removedWaypoints = _presentation$removeN2.removedWaypoints;
  }

  var result = self.store.deleteNodes({ nodeIds: nodeIds, linkIds: linkIds });
  var operationMessages = [];

  if (result) {
    _perspectivesUi.pui.deleteElements(result, operationMessages);

    if (updatedWaypoints && updatedWaypoints.length) {
      for (var _iterator30 = updatedWaypoints, _isArray30 = Array.isArray(_iterator30), _i32 = 0, _iterator30 = _isArray30 ? _iterator30 : _iterator30[Symbol.iterator]();;) {
        var _ref44;

        if (_isArray30) {
          if (_i32 >= _iterator30.length) break;
          _ref44 = _iterator30[_i32++];
        } else {
          _i32 = _iterator30.next();
          if (_i32.done) break;
          _ref44 = _i32.value;
        }

        var updatedWaypoint = _ref44;

        operationMessages.push(_this.operation.messages.updatePresentationWaypointNodeIds({
          presentationUUID: presentationUUID,
          waypointUUID: updatedWaypoint.id,
          nodeIds: updatedWaypoint.nodeIds,
          prevNodeIds: updatedWaypoint.prevNodeIds
        }));
      }
    }

    if (removedWaypoints && removedWaypoints.length) {
      for (var _iterator31 = removedWaypoints, _isArray31 = Array.isArray(_iterator31), _i33 = 0, _iterator31 = _isArray31 ? _iterator31 : _iterator31[Symbol.iterator]();;) {
        var _ref45;

        if (_isArray31) {
          if (_i33 >= _iterator31.length) break;
          _ref45 = _iterator31[_i33++];
        } else {
          _i33 = _iterator31.next();
          if (_i33.done) break;
          _ref45 = _i33.value;
        }

        var waypoint = _ref45;

        operationMessages.push(_this.operation.messages.removePresentationWaypoint({
          presentationUUID: presentationUUID,
          waypoint: waypoint
        }));
      }
    }

    if (removedWaypoints && removedWaypoints.length || updatedWaypoints && updatedWaypoints.length) {
      _waypointsUi2.default.updateWaypoints();
    }

    var deleteNodeMessage = self.operation.messages.deleteNodes({
      nodeIds: nodeIds,
      linkIds: linkIds,
      deletedNodeIds: result.deletedNodeIds || [],
      deletedLinkIds: result.deletedLinkIds || [],
      deletedLinkNodesMap: result.deletedLinkNodesMap || {}
    });
    operationMessages.push(deleteNodeMessage);
  }

  _regionUi.regionUI.deleteSelectedRegions({ operationMessages: operationMessages });
  _drawingUi.drawingUI.deleteSelectedDrawings({ operationMessages: operationMessages });

  if (operationMessages.length) {
    _this.operation.batchOperation({
      messages: operationMessages,
      onFailure: function onFailure(err) {
        console.warn('deleteSelectedElements batchOperation failed: ' + err);
      }
    });
  }
  if (result && result.deletedNodeIds && result.deletedNodeIds.length) {
    self.nodesTag.update();
    // readjust lines connecting to affected cards
    for (var _iterator32 = topLevelParentIds, _isArray32 = Array.isArray(_iterator32), _i34 = 0, _iterator32 = _isArray32 ? _iterator32 : _iterator32[Symbol.iterator]();;) {
      var _ref46;

      if (_isArray32) {
        if (_i34 >= _iterator32.length) break;
        _ref46 = _iterator32[_i34++];
      } else {
        _i34 = _iterator32.next();
        if (_i34.done) break;
        _ref46 = _i34.value;
      }

      var id = _ref46;

      if (self.nodeTags[id]) {
        self.nodeTags[id].updateTopLevelNeighborsLite();
      }
    }
  }
  if (result && result.deletedLinkIds && result.deletedLinkIds.length) {
    self.linksTag.update();
  }
  self.clearSelectedElements();
  _this.hidePopups();
  _searchUi.searchUI.refreshResults();
  self.waypointsTabTag && self.waypointsTabTag.refreshIfNeeded();
  if (result) {
    _this.openUndoBanner({
      deletedNodeCount: result.deletedNodeIds ? result.deletedNodeIds.length : 0,
      deletedLinkCount: result.deletedLinkIds ? result.deletedLinkIds.length : 0
    });
  }
  if (!window.pageSettings.hideMapHeader && !window.pageSettings.hideMapMenu) {
    _this.appHeaderTag.update();
  }
  _this.appFooterTag.update();
};

this.createSystemFromSelection = function () {
  return _systemsUi.systemsUI.createSystemFromSelection();
};

this.triggerPostinitialization = function () {
  if (Object.keys(_this.nodeTags).length == _store_instance2.default.nodes.size && Object.keys(_this.regionTags).length == _store_instance2.default.getRegions().length && Object.keys(_this.drawingTags).length == _store_instance2.default.getDrawings().length) {
    _this.postInitialization();
  }
};

// run this after every node has been mounted (called from node.html on mount)
this.postInitialization = function () {
  // only call this once
  if (_this.postInitializationComplete) {
    return;
  }

  if (_mobile2.default.isTouchOnly()) {
    _this.isMobile = true;
    _zoomUi.zoomUI.disableSemanticZoom();
    $(self.refs.canvas).panzoom("option", { minScale: 0 });
  }

  _appUi.appUI.freshen();

  _this.postInitializationComplete = true;
  _this.matrix = _zoomUi.zoomUI.getMatrix();

  var _window$config$zoomTo = window.config.zoomToId,
      _window$config$zoomTo2 = _window$config$zoomTo.nodeId,
      nodeId = _window$config$zoomTo2 === undefined ? '' : _window$config$zoomTo2,
      _window$config$zoomTo3 = _window$config$zoomTo.regionId,
      regionId = _window$config$zoomTo3 === undefined ? '' : _window$config$zoomTo3,
      _window$config$zoomTo4 = _window$config$zoomTo.commentId,
      commentId = _window$config$zoomTo4 === undefined ? '' : _window$config$zoomTo4;

  if (nodeId || regionId) {
    var zoomNodeIds = nodeId.split("%2C");
    var zoomRegionIds = regionId.split("%2C");
    var centeringNodes = _store_instance2.default.filterNodes(function (n) {
      return zoomNodeIds.includes(n.id);
    });
    var centeringRegions = zoomRegionIds.filter(function (id) {
      return _store_instance2.default.getRegion(id);
    }).map(function (id) {
      return { id: id };
    });

    if (centeringNodes.length || centeringRegions.length) {
      _this.centerContent({
        nodes: centeringNodes,
        regions: centeringRegions
      });

      _this.setSelectedElements(centeringNodes.map(function (n) {
        return self.nodeTags[n.id];
      }));
    } else {
      _this.fitMapContents();
    }
  } else if (commentId) {
    setTimeout(function () {
      _commentsUi.commentsUI.panToComment(commentId, true);
    }, 500);
  } else {
    _this.fitMapContents();
  }

  if (_mobile2.default.isTouchOnly() && !_this.forceDesktop) {
    _this.retrofitTouchOnly();
  }

  if (window.config.present) {
    var waypoints = _waypointsUi2.default.getWaypoints();
    _presentationUi2.default.start({ slides: waypoints });
  }

  if (!_this.isViewOnly() && window.user && window.user.should_show_intro) {
    _this.openSidebar('user-guide');
  }
};

this.realignAllLinks = function () {
  var nodes = _this.store.topNodes();
  if (nodes) {
    for (var _iterator33 = nodes, _isArray33 = Array.isArray(_iterator33), _i35 = 0, _iterator33 = _isArray33 ? _iterator33 : _iterator33[Symbol.iterator]();;) {
      var _ref47;

      if (_isArray33) {
        if (_i35 >= _iterator33.length) break;
        _ref47 = _iterator33[_i35++];
      } else {
        _i35 = _iterator33.next();
        if (_i35.done) break;
        _ref47 = _i35.value;
      }

      var node = _ref47;

      var nodeTag = _this.nodeTags[node.id];
      if (nodeTag) {
        nodeTag.updateTopLevelNeighborsLite();
      }
    }
    (0, _util.refreshFreehandAncestorsOfList)(Array.from(_store_instance2.default.getNodes()), _this, _store_instance2.default);
  }
};

// make this suitable for view-only mode on a phone
this.retrofitTouchOnly = function () {

  var body = document.body.cloneNode(true);
  // bruatally wipe out event listeners!
  document.body.replaceWith(document.body.cloneNode(true));
  for (var _iterator34 = document.querySelectorAll("[contenteditable=true]"), _isArray34 = Array.isArray(_iterator34), _i36 = 0, _iterator34 = _isArray34 ? _iterator34 : _iterator34[Symbol.iterator]();;) {
    var _ref48;

    if (_isArray34) {
      if (_i36 >= _iterator34.length) break;
      _ref48 = _iterator34[_i36++];
    } else {
      _i36 = _iterator34.next();
      if (_i36.done) break;
      _ref48 = _i36.value;
    }

    var el = _ref48;

    el.removeAttribute('contenteditable');
  }
  window.log = document.querySelector("#log");
  document.body.classList.add('hide-app-chrome');
  document.body.classList.add('view-only-mobile');
  var main = document.querySelector("main");
  var $window = $(window);
  var vw = $window.width();
  var vh = $window.height();
  main.style.width = vw + 'px';
  main.style.height = vh + 'px';
  main.style.overflow = 'hidden';
  main.style.minHeight = 'auto';

  window.addEventListener('orientationchange', function (e) {
    // reload when the orientation changes so that the map
    // stays centered in the viewport
    window.location.reload();
  });
};

this.fitSelectionOrMap = function () {
  var selectedNodes = self.getSelectedNodes();
  var selectedRegions = _regionUi.regionUI.getSelectedRegions();
  var selectedDrawings = _drawingUi.drawingUI.getSelectedDrawings();
  var selectedLinks = self.getSelectedLinks();

  if (selectedNodes.length || selectedLinks.length || selectedRegions.length || selectedDrawings.length) {
    var selectedDescendants = [];
    var flatMap = function flatMap(arr, cb) {
      var _ref49;

      return (_ref49 = []).concat.apply(_ref49, arr.map(cb));
    };
    if (selectedNodes.length) {
      selectedDescendants = flatMap(selectedNodes, function (node) {
        var descendants = node.descendants();
        descendants.push(node);
        return descendants;
      });
    }
    self.centerContent({
      nodes: selectedDescendants,
      links: selectedLinks,
      regions: selectedRegions,
      drawings: selectedDrawings
    });
  } else {
    var _store = self.store;

    self.centerContent({
      nodes: Array.from(_store.getNodes()),
      links: _store.getLinks(),
      regions: _store.getRegions(),
      drawings: _store.getDrawings()
    });
  }
};

this.fitMapContents = function () {
  var store = self.store;

  self.centerContent({
    nodes: Array.from(store.getNodes()),
    links: store.getLinks(),
    regions: store.getRegions(),
    drawings: store.getDrawings()
  });
};

this.getContentExtents = function (_ref50) {
  var _ref50$nodes = _ref50.nodes,
      nodes = _ref50$nodes === undefined ? [] : _ref50$nodes,
      _ref50$links = _ref50.links,
      links = _ref50$links === undefined ? [] : _ref50$links,
      _ref50$regions = _ref50.regions,
      regions = _ref50$regions === undefined ? [] : _ref50$regions,
      _ref50$drawings = _ref50.drawings,
      drawings = _ref50$drawings === undefined ? [] : _ref50$drawings;

  nodes = nodes.filter(function (n) {
    return !n.hidden && n.getTopLevelParent().isShownNodeType();
  });
  if (nodes.length === 0 && links.length === 0 && regions.length === 0 && drawings.length === 0) return;

  var _self$getMatrix = self.getMatrix(),
      scale = _self$getMatrix.scale,
      tx = _self$getMatrix.tx,
      ty = _self$getMatrix.ty;

  var et = Infinity,
      el = Infinity,
      eb = -Infinity,
      er = -Infinity;

  for (var _iterator35 = nodes, _isArray35 = Array.isArray(_iterator35), _i37 = 0, _iterator35 = _isArray35 ? _iterator35 : _iterator35[Symbol.iterator]();;) {
    var _ref51;

    if (_isArray35) {
      if (_i37 >= _iterator35.length) break;
      _ref51 = _iterator35[_i37++];
    } else {
      _i37 = _iterator35.next();
      if (_i37.done) break;
      _ref51 = _i37.value;
    }

    var node = _ref51;

    // get accurating positions of all node, but especially R nodes
    // since they're affected by a translate(50% ) that shifts their apparent position
    var nodeTag = _this.nodeTags[node.id];
    if (!(nodeTag && nodeTag.refs && nodeTag.refs.container)) continue;

    var mediaRectToMeasure = nodeTag.refs.image || nodeTag.refs.video;
    if (nodeTag.instance.cardless && !mediaRectToMeasure) continue;

    var _rect3 = nodeTag.instance.cardless ? mediaRectToMeasure.getBoundingClientRect() : nodeTag.refs.screen.getBoundingClientRect();

    var _cr3 = (_rect3.right - tx) / scale;
    var _cb3 = (_rect3.bottom - ty) / scale;
    var _cl3 = (_rect3.left - tx) / scale - 3;
    var _ct3 = (_rect3.top - ty) / scale - 3;

    // popped out parts
    if (nodeTag.instance.getChildrenDetached() && !nodeTag.instance.isCollapsed && nodeTag.childNodesTag && nodeTag.childNodesTag.refs.container) {
      var childRect = nodeTag.childNodesTag.refs.container.getBoundingClientRect();
      var ar = (childRect.right - tx) / scale;
      var ab = (childRect.bottom - ty) / scale;
      var al = (childRect.left - tx) / scale;
      var at = (childRect.top - ty) / scale;
      if (ar > _cr3) _cr3 = ar;
      if (ab > _cb3) _cb3 = ab;
      if (at < _ct3) _ct3 = at;
      if (al < _cl3) _cl3 = al;
    }

    // if node has annotations
    //
    var perspectiveDots = nodeTag.getPerspectiveDots();
    if (perspectiveDots) {
      var dots = perspectiveDots.getDots();
      for (var _iterator39 = dots, _isArray39 = Array.isArray(_iterator39), _i41 = 0, _iterator39 = _isArray39 ? _iterator39 : _iterator39[Symbol.iterator]();;) {
        var _ref55;

        if (_isArray39) {
          if (_i41 >= _iterator39.length) break;
          _ref55 = _iterator39[_i41++];
        } else {
          _i41 = _iterator39.next();
          if (_i41.done) break;
          _ref55 = _i41.value;
        }

        var dot = _ref55;

        if (dot.getAnnotationTag() && dot.getAnnotationTag().showAnnotation()) {
          // get annotation position and adjust the bounding box of the current node if the annotations are outside its boundaries
          var annotationRect = dot.getAnnotationTag().getAnnotationBoundingBox();
          var _ar = (annotationRect.right - tx) / scale;
          var _ab = (annotationRect.bottom - ty) / scale;
          var _al = (annotationRect.left - tx) / scale;
          var _at = (annotationRect.top - ty) / scale;
          if (_ar > _cr3) _cr3 = _ar;
          if (_ab > _cb3) _cb3 = _ab;
          if (_at < _ct3) _ct3 = _at;
          if (_al < _cl3) _cl3 = _al;
        }
      }
    }

    if (_cr3 > er) er = _cr3;
    if (_cb3 > eb) eb = _cb3;
    if (_ct3 < et) et = _ct3;
    if (_cl3 < el) el = _cl3;
  }

  if (regions && regions.length) {
    for (var _iterator36 = regions, _isArray36 = Array.isArray(_iterator36), _i38 = 0, _iterator36 = _isArray36 ? _iterator36 : _iterator36[Symbol.iterator]();;) {
      var _ref52;

      if (_isArray36) {
        if (_i38 >= _iterator36.length) break;
        _ref52 = _iterator36[_i38++];
      } else {
        _i38 = _iterator36.next();
        if (_i38.done) break;
        _ref52 = _i38.value;
      }

      var region = _ref52;

      var regionTag = _this.regionTags[region.id];
      var rect = regionTag.refs.main.getBoundingClientRect();

      var cr = (rect.right - tx) / scale - 2;
      var cb = (rect.bottom - ty) / scale - 2;
      var cl = (rect.left - tx) / scale - 2;
      var ct = (rect.top - ty) / scale - 2;

      if (cr > er) er = cr;
      if (cb > eb) eb = cb;
      if (ct < et) et = ct;
      if (cl < el) el = cl;
    }
  }

  if (drawings && drawings.length) {
    for (var _iterator37 = drawings, _isArray37 = Array.isArray(_iterator37), _i39 = 0, _iterator37 = _isArray37 ? _iterator37 : _iterator37[Symbol.iterator]();;) {
      var _ref53;

      if (_isArray37) {
        if (_i39 >= _iterator37.length) break;
        _ref53 = _iterator37[_i39++];
      } else {
        _i39 = _iterator37.next();
        if (_i39.done) break;
        _ref53 = _i39.value;
      }

      var drawing = _ref53;

      var drawingTag = _this.drawingTags[drawing.id];
      var _rect = drawingTag.root.getBoundingClientRect();

      var _cr = (_rect.right - tx) / scale - 2;
      var _cb = (_rect.bottom - ty) / scale - 2;
      var _cl = (_rect.left - tx) / scale - 2;
      var _ct = (_rect.top - ty) / scale - 2;

      if (_cr > er) er = _cr;
      if (_cb > eb) eb = _cb;
      if (_ct < et) et = _ct;
      if (_cl < el) el = _cl;
    }
  }

  //https://bugzilla.mozilla.org/show_bug.cgi?id=1541021
  //firefox doesn't account for css transforms with getBoundingClientRect and svgs...
  //Seems like this is fixed as of firefox 68, but unfortunately the newest firefox
  //out now is 66
  if (!_this.isFirefox && links && links.length) {
    for (var _iterator38 = links, _isArray38 = Array.isArray(_iterator38), _i40 = 0, _iterator38 = _isArray38 ? _iterator38 : _iterator38[Symbol.iterator]();;) {
      var _ref54;

      if (_isArray38) {
        if (_i40 >= _iterator38.length) break;
        _ref54 = _iterator38[_i40++];
      } else {
        _i40 = _iterator38.next();
        if (_i40.done) break;
        _ref54 = _i40.value;
      }

      var link = _ref54;

      var linkTag = _this.linkTags[link.id];
      if (!link.showArc() || !linkTag || !linkTag.refs || !linkTag.refs.svg) continue;
      var _rect2 = linkTag.refs.svg.getBoundingClientRect();
      if (_rect2.top === _rect2.left === _rect2.right === _rect2.bottom === 0) {
        // keep going if we got likely bogus measurements
        continue;
      }

      var _cr2 = (_rect2.right - tx) / scale;
      var _cb2 = (_rect2.bottom - ty) / scale;
      var _cl2 = (_rect2.left - tx) / scale;
      var _ct2 = (_rect2.top - ty) / scale;

      if (_cr2 > er) er = _cr2;
      if (_cb2 > eb) eb = _cb2;
      if (_ct2 < et) et = _ct2;
      if (_cl2 < el) el = _cl2;
    }
  }

  var _map = [et, el, eb, er].map(function (x) {
    return Math.round(x);
  });

  et = _map[0];
  el = _map[1];
  eb = _map[2];
  er = _map[3];

  return [et, el, eb, er];
};

// get pan/zoom needed to fit the map into
this.getMapViewport = function (_ref56) {
  var nodes = _ref56.nodes,
      links = _ref56.links,
      regions = _ref56.regions,
      drawings = _ref56.drawings;

  // We only care about visible nodes
  nodes = nodes.filter(function (n) {
    return n && !n.hidden && n.getTopLevelParent().isShownNodeType();
  });
  if (nodes.length === 0) return;

  var _getContentExtents = _this.getContentExtents({ nodes: nodes, links: links, regions: regions, drawings: drawings }),
      et = _getContentExtents[0],
      el = _getContentExtents[1],
      eb = _getContentExtents[2],
      er = _getContentExtents[3];

  var MARGIN = 50;
  var height = eb - et + MARGIN * 2;
  var width = er - el + MARGIN * 2;

  // ensure content is centered in exported image
  var minX = el - MARGIN;
  var minY = et - MARGIN / 2;

  // if tags are present, capture the width of the legend
  var sidebarWidth = 0;
  var perspectivesPresent = _store_instance2.default.perspectives && _store_instance2.default.perspectives.length && _this.toolsSidebarTag && _this.toolsSidebarTag.isOpen;
  if (perspectivesPresent) {
    var sidebarDimensions = _this.toolsSidebarTag.refs.tabs.getBoundingClientRect();
    sidebarWidth = sidebarDimensions.right - sidebarDimensions.left;
  }
  return { minX: minX, minY: minY, height: height, width: width, scale: 1, sidebarWidth: sidebarWidth };
};

this.openUndoBanner = function (_ref57) {
  var deletedNodeCount = _ref57.deletedNodeCount,
      deletedLinkCount = _ref57.deletedLinkCount;

  _this.undoBanner.open = true;
  if (deletedNodeCount) {
    _this.undoBanner.deletedNodeCount = deletedNodeCount;
    _this.appFooterTag.updateStyle();
  }
  if (deletedLinkCount) {
    _this.undoBanner.deletedLinkCount = deletedLinkCount;
  }
  if (!window.pageSettings.hideMapHeader && !window.pageSettings.hideMapMenu) {
    _this.bulkActionsMenuTag.update();
    _this.tags['undo-banner'].update();
  }
  clearTimeout(_this.undoBannerTimeout);
  _this.undoBannerTimeout = setTimeout(_this.closeUndoBanner, _constants.UNDO_BANNER_TIMEOUT);
};

this.closeUndoBanner = function () {
  _this.undoBanner.open = false;
  _this.undoBanner.deletedLinkCount = 0;
  _this.undoBanner.deletedNodeCount = 0;
  if (!window.pageSettings.hideMapHeader && !window.pageSettings.hideMapMenu) {
    _this.tags['undo-banner'].update();
  }
};

this.showTempDownloadStatus = function () {
  $(_this.refs.downloadStatus).fadeIn();

  setTimeout(function () {
    $(_this.refs.downloadStatus).fadeOut();
  }, 3000);
};

this.centerContent = function (_ref58) {
  var _ref58$nodes = _ref58.nodes,
      nodes = _ref58$nodes === undefined ? [] : _ref58$nodes,
      _ref58$links = _ref58.links,
      links = _ref58$links === undefined ? [] : _ref58$links,
      _ref58$regions = _ref58.regions,
      regions = _ref58$regions === undefined ? [] : _ref58$regions,
      _ref58$drawings = _ref58.drawings,
      drawings = _ref58$drawings === undefined ? [] : _ref58$drawings;
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // We only care about visible nodes
  nodes = nodes.filter(function (n) {
    return !n.hidden && n.getTopLevelParent().isShownNodeType();
  });
  if (nodes.length === 0 && links.length === 0 && regions.length === 0 && drawings.length === 0) return;
  // find extents...

  var _getContentExtents2 = _this.getContentExtents({ nodes: nodes, links: links, regions: regions, drawings: drawings }),
      et = _getContentExtents2[0],
      el = _getContentExtents2[1],
      eb = _getContentExtents2[2],
      er = _getContentExtents2[3];

  _this.panZoomTo([et, el, eb, er], opts.scale, opts);
};

// panzoom to just the title/summary of a given node
this.panzoomToTextCenter = function (element, newScale, opts) {
  if (opts === undefined) {
    opts = {};
  }
  if (!element) {
    return;
  }
  var extents = void 0;
  if (element instanceof _store2.Node) {
    var nodeTag = self.nodeTags[element.id];
    if (!nodeTag) {
      return;
    }
    var rect = nodeTag.refs.info.getBoundingClientRect();

    extents = _this.getNodeExtents({
      absolutePosition: element.absolutePosition,
      width: rect.width,
      height: rect.height,
      x: element.x,
      y: element.y
    });
  } else if (element instanceof _store2.Region) {
    extents = [element.top, element.left, element.bottom, element.right];
  }
  if (extents) {
    _this.panZoomTo(extents, newScale, opts);
  }
};

this.getNodeExtents = function (_ref59) {
  var absolutePosition = _ref59.absolutePosition,
      width = _ref59.width,
      height = _ref59.height,
      x = _ref59.x,
      y = _ref59.y;

  var er = (absolutePosition.x || x) + (width || 0);
  var eb = (absolutePosition.y || y) + (height || 0);
  var el = absolutePosition.x || x;
  var et = absolutePosition.y || y;

  return [et, el, eb, er].map(function (num) {
    return Math.round(num);
  });
};

// panzoom to the given bounding box + optional scale (zoom to fit if scale is null)
this.panZoomTo = function (extents, scale) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var et = extents[0],
      el = extents[1],
      eb = extents[2],
      er = extents[3];

  var windowWidth = void 0,
      windowHeight = void 0;
  windowWidth = $(window).width();
  windowHeight = $(window).height();

  if (_mobile2.default.isTouchOnly()) {
    // leave room for the mobile banner
    if (windowWidth < windowHeight) {
      windowHeight -= $(window).width() * .10;
    } else {
      windowHeight -= $(window).height() * .10;
    }
  }
  // application chrome in margins in screen pixels
  var CHROME_LEFT_MARGIN = 0;
  var CHROME_RIGHT_MARGIN = 0;
  var CHROME_TOP_MARGIN = 50;
  var CHROME_BOTTOM_MARGIN = 40;

  // padding in map pixels
  var LEFT_MAP_PADDING = 50;
  var RIGHT_MAP_PADDING = 50;
  var TOP_MAP_PADDING = 70;
  var BOTTOM_MAP_PADDING = 70;

  if (_this.sidebarStatus && _this.sidebarStatus !== 'closed') {
    if (!opts || !opts.ignoreSidebars) {
      CHROME_RIGHT_MARGIN = _constants.WIDTHS.SIDEBAR_WIDTH;
    }
  }

  var toolsSidebarTag = _this.toolsSidebarTag;

  if (toolsSidebarTag && !_this.zenMode) {
    CHROME_LEFT_MARGIN = $(toolsSidebarTag.isOpen ? toolsSidebarTag.root : toolsSidebarTag.refs.tools).outerWidth();
  }

  var CHROME_HORIZONTAL_MARGIN = CHROME_LEFT_MARGIN + CHROME_RIGHT_MARGIN;
  var CHROME_VERTICAL_MARGIN = CHROME_TOP_MARGIN + CHROME_BOTTOM_MARGIN;

  var HORIZONTAL_MAP_PADDING = LEFT_MAP_PADDING + RIGHT_MAP_PADDING;
  var VERTICAL_MAP_PADDING = TOP_MAP_PADDING + BOTTOM_MAP_PADDING;

  var $canvas = $(_this.refs.canvas);
  var widthScale = (windowWidth - CHROME_HORIZONTAL_MARGIN) / (er - el + HORIZONTAL_MAP_PADDING);
  var heightScale = (windowHeight - CHROME_VERTICAL_MARGIN) / (eb - et + VERTICAL_MAP_PADDING);
  var newScale = void 0;
  if (scale) {
    newScale = scale;
  } else {
    var maxScale = Math.min(opts.maxScale, $canvas.panzoom('option').maxScale);
    newScale = Math.min(widthScale, heightScale, maxScale || 1);
  }

  if (newScale !== 1) newScale = _zoomUi.zoomUI.roundScale(newScale);

  $canvas.panzoom('zoom', newScale);

  var adjustX = (windowWidth - CHROME_HORIZONTAL_MARGIN - newScale * (er - el + HORIZONTAL_MAP_PADDING)) / 2;
  var adjustY = (windowHeight - CHROME_VERTICAL_MARGIN - newScale * (eb - et + VERTICAL_MAP_PADDING)) / 2;
  var panX = -(5000 + (el - LEFT_MAP_PADDING) * newScale) + adjustX + CHROME_LEFT_MARGIN;
  var panY = -(5000 + (et - TOP_MAP_PADDING) * newScale) + adjustY + CHROME_TOP_MARGIN;

  var panzoomOptions = Object.assign({ relative: false }, opts);
  $canvas.panzoom('pan', panX, panY, panzoomOptions);

  _zoomUi.zoomUI.unsetPanzoomingFlag();
};

// refresh annotations when toggling between popped out / in
this.redrawAnnotations = function () {
  var affectedNodeTags = [];

  var _loop = function _loop(key) {
    var tag = _this.nodePerspectiveAnnotations[key];
    if (_this.annotationStyle == 'popout') {
      tag.shuttleToPopout();
    } else if (_this.annotationStyle == 'in_card') {
      tag.shuttleToCard();
    }
    if (!affectedNodeTags.find(function (t) {
      return t.id == tag.nodeTag.id;
    })) {
      affectedNodeTags.push(tag.nodeTag);
    }
  };

  for (var key in _this.nodePerspectiveAnnotations) {
    _loop(key);
  }

  for (var _iterator40 = affectedNodeTags, _isArray40 = Array.isArray(_iterator40), _i42 = 0, _iterator40 = _isArray40 ? _iterator40 : _iterator40[Symbol.iterator]();;) {
    var _ref60;

    if (_isArray40) {
      if (_i42 >= _iterator40.length) break;
      _ref60 = _iterator40[_i42++];
    } else {
      _i42 = _iterator40.next();
      if (_i42.done) break;
      _ref60 = _i42.value;
    }

    var nodeTag = _ref60;

    nodeTag.updateTopLevelNeighborsLite();
  }
};

this.summonRightClickMenu = function (e) {
  if (!e.altKey) {
    e.preventDefault();

    _this.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      isCanvas: true
    });

    _eventTracking2.default.track({
      category: 'Right-Click-Menu',
      action: 'Right-Click-Menu-Open',
      label: 'Right-Click-Menu-Open'
    });
  }
};

this.toggleZenMode = function () {
  _this.zenMode = !Boolean(_this.zenMode);
  if (_this.zenMode) {
    _this.setZenMode();
    _this.hidePopups();
    _delayHandler.delayHandler.clearDelayFor('zen-mode-instructions-tip');
    _this.zenModeTag.showHint();
    canvas.zenModeEdgeHover = false;
    _eventTracking2.default.track({
      category: 'Map-Header',
      action: 'Zen Mode On',
      label: 'Header Zen Mode On'
    });
  } else {
    _delayHandler.delayHandler.clearDelayFor('zen-mode-instructions-tip');
    _this.unSetZenMode();
    _eventTracking2.default.track({
      category: 'Map-Header',
      action: 'Zen Mode Off',
      label: 'Header Zen Mode Off'
    });
  }
  _this.appHeaderTag.update();
};

this.setZenMode = function () {
  document.body.classList.add('zen-mode');
  _this.root.classList.add('zen-mode');
};

this.unSetZenMode = function () {
  var $sidebar = $(_this.toolsSidebarTag.root);
  var intercomEl = document.getElementById('intercom-launch-button');
  if (intercomEl) intercomEl.style = "";

  document.body.classList.remove('zen-mode');
  _this.root.classList.remove('zen-mode');
  $sidebar.addClass('unsetting-zen-mode');

  $sidebar.on('transitionend', function () {
    $sidebar.off('transitionend');
    $sidebar.removeClass('unsetting-zen-mode');
  });
};

this.attachRightClickDismissEvent = function (element) {
  element.addEventListener('click', function (e) {
    if (_this.rightClickMenuIsOpen()) {
      _this.hideRightClickMenu();
    }
  });
};

this.showTextToolbarOnSelect = function () {
  // show the toolbar when the user mouseup's at the conclusion
  // of their selection, or when the selection changes by keyboard
  // or other means like right clicking and choosing select all
  var mouseDown = false;
  var pendingSelectionChange = false;

  document.addEventListener('mousedown', function (e) {
    if (!e.target.hasAttribute('data-no-selection-change')) {
      mouseDown = true;
    }
  }, true);
  document.addEventListener('mouseup', function (e) {
    mouseDown = false;

    if (pendingSelectionChange) {
      pendingSelectionChange = false;
      _this.tags['text-toolbar'].toggle();
    }
  });
  document.addEventListener('selectionchange', function (e) {
    if (mouseDown && window.getSelection().toString()) {
      pendingSelectionChange = true;
    } else {
      _this.tags['text-toolbar'].toggle();
    }
  });
};

this.setSaving = function () {
  _this.headerSaveIndicator && _this.headerSaveIndicator.setSaving();
};

this.setSaved = function () {
  _this.headerSaveIndicator && _this.headerSaveIndicator.setSaved();
};

this.setSaveFailed = function () {
  _this.headerSaveIndicator && _this.headerSaveIndicator.setSaveFailed();
};

/*
  draw a rectangle on the canvas for debugging purposes
  (takes the output of getBoundingClientRect() )
*/
this.drawDebuggingRect = function (rect) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgba(255,0,0,0.05)';

  var point = _appUi.appUI.viewportCoordsToMapCoords({ x: rect.left, y: rect.top });
  var point2 = _appUi.appUI.viewportCoordsToMapCoords({ x: rect.right, y: rect.bottom });
  $(_this.nodesTag.refs.topNodes).append('<div style="z-index: 9999; background: ' + color + '; left: ' + point.x + 'px; top: ' + point.y + 'px; height: ' + (point2.y - point.y) + 'px; width: ' + (point2.x - point.x) + 'px; position: absolute;"></div>');
};

this.setCursor = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  var toolName = arguments[1];
  var _document = document,
      documentElement = _document.documentElement;
  var sketchpadTag = _this.sketchpadTag;

  if (sketchpadTag) {
    if (toolName === 'pen-tool') {
      sketchpadTag.root.style.cursor = value;
    } else {
      sketchpadTag.root.style.removeProperty('cursor');
    }
  }

  documentElement.style.setProperty('--active-tool-cursor', value);

  if (toolName === 'text') {
    documentElement.style.setProperty('--relationship-tool-cursor', value);
  } else {
    documentElement.style.removeProperty('--relationship-tool-cursor');
  }

  if (['basic-card', 'image', 'text'].includes(toolName)) {
    _this.refs.pannable.style.cursor = value;
    return;
  } else {
    _this.refs.pannable.style.cursor = 'default';
  }

  _this.regionCreationToolTag.root.style.cursor = value;
};

window.addEventListener('message', _appUi.appUI.receivePostMessage);
this.showTextToolbarOnSelect();

this.isFeatureEnabled = function (feature) {
  return window.enabled_features[feature];
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('app')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/app.html
// module id = 615
// module chunks = 0